// GENERATED by scripts/importSong.ts from song-imports/apt/ -- re-run the
// importer to regenerate rather than hand-editing the chart notes below.
import type { SongMeta } from '@/types';

export const aptSong: SongMeta = {
  "id": "apt",
  "title": "Apt",
  "artist": "Imported",
  "bpm": 120,
  "duration": 174.86,
  "audio": "audio/songs/apt.mp3",
  "vocalsAudio": "audio/songs/apt-vocals.mp3",
  "difficulty": 3,
  "background": "sunsetHill",
  "chart": {
    "noteTravelTime": 1.9,
    "notes": [
      {
        "time": 2.464,
        "lane": "left",
        "x": 0.1,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.083
      },
      {
        "time": 2.656,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.135
      },
      {
        "time": 2.844,
        "lane": "left",
        "x": 0.22,
        "type": "donut",
        "pitch": 67,
        "vocalDuration": 0.219
      },
      {
        "time": 3.063,
        "lane": "right",
        "x": 0.59,
        "type": "cupcake",
        "pitch": 67,
        "vocalDuration": 0.219
      },
      {
        "time": 3.281,
        "lane": "left",
        "x": 0.35,
        "type": "candy",
        "pitch": 67,
        "vocalDuration": 0.219
      },
      {
        "time": 3.505,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.375
      },
      {
        "time": 3.917,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.292
      },
      {
        "time": 4.208,
        "lane": "right",
        "x": 0.36,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.365
      },
      {
        "time": 4.578,
        "lane": "left",
        "x": 0.62,
        "type": "donut",
        "pitch": 72,
        "vocalDuration": 0.333
      },
      {
        "time": 4.943,
        "lane": "right",
        "x": 0.24,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.207
      },
      {
        "time": 5.149,
        "lane": "left",
        "x": 0.61,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.207
      },
      {
        "time": 5.356,
        "lane": "right",
        "x": 0.12,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.207
      },
      {
        "time": 5.563,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.203
      },
      {
        "time": 6.255,
        "lane": "right",
        "x": 0.34,
        "type": "fish",
        "pitch": 85,
        "vocalDuration": 0.156
      },
      {
        "time": 6.552,
        "lane": "left",
        "x": 0.37,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.266
      },
      {
        "time": 6.823,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.354
      },
      {
        "time": 7.182,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 72,
        "vocalDuration": 0.245
      },
      {
        "time": 7.443,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 74,
        "vocalDuration": 0.068
      },
      {
        "time": 8.365,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.078
      },
      {
        "time": 8.51,
        "lane": "right",
        "x": 0.6,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.099
      },
      {
        "time": 9.911,
        "lane": "left",
        "x": 0.17,
        "type": "donut",
        "pitch": 59,
        "vocalDuration": 0.078
      },
      {
        "time": 10.958,
        "lane": "right",
        "x": 0.58,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.249
      },
      {
        "time": 11.207,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.249
      },
      {
        "time": 11.456,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.249
      },
      {
        "time": 11.704,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.249
      },
      {
        "time": 11.958,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.12
      },
      {
        "time": 12.083,
        "lane": "left",
        "x": 0.56,
        "type": "donut",
        "pitch": 62,
        "vocalDuration": 0.089
      },
      {
        "time": 12.458,
        "lane": "right",
        "x": 0.21,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.13
      },
      {
        "time": 12.599,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.271
      },
      {
        "time": 12.901,
        "lane": "right",
        "x": 0.09,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.073
      },
      {
        "time": 12.979,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.238
      },
      {
        "time": 13.217,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.238
      },
      {
        "time": 13.456,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.238
      },
      {
        "time": 13.694,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.238
      },
      {
        "time": 13.948,
        "lane": "left",
        "x": 0.22,
        "type": "candy",
        "pitch": 67,
        "vocalDuration": 0.104
      },
      {
        "time": 14.479,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.214
      },
      {
        "time": 14.693,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.214
      },
      {
        "time": 14.906,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.214
      },
      {
        "time": 15.12,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.214
      },
      {
        "time": 15.339,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.297
      },
      {
        "time": 15.635,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.297
      },
      {
        "time": 16.432,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.13
      },
      {
        "time": 16.568,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.109
      },
      {
        "time": 17.229,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.292
      },
      {
        "time": 17.703,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 17.974,
        "lane": "right",
        "x": 0.22,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.229
      },
      {
        "time": 18.307,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.13
      },
      {
        "time": 18.438,
        "lane": "right",
        "x": 0.09,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.233
      },
      {
        "time": 18.671,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.233
      },
      {
        "time": 18.904,
        "lane": "right",
        "x": 0.21,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.233
      },
      {
        "time": 19.137,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.233
      },
      {
        "time": 19.38,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.146
      },
      {
        "time": 19.526,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.208
      },
      {
        "time": 19.734,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.208
      },
      {
        "time": 19.948,
        "lane": "left",
        "x": 0.1,
        "type": "iceCream",
        "pitch": 67,
        "vocalDuration": 0.115
      },
      {
        "time": 20.469,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.245
      },
      {
        "time": 20.714,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.245
      },
      {
        "time": 20.958,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.245
      },
      {
        "time": 21.203,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.245
      },
      {
        "time": 21.448,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.245
      },
      {
        "time": 21.693,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.245
      },
      {
        "time": 21.938,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.125
      },
      {
        "time": 22.422,
        "lane": "left",
        "x": 0.58,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.063
      },
      {
        "time": 22.49,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.286
      },
      {
        "time": 22.781,
        "lane": "left",
        "x": 0.58,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.229
      },
      {
        "time": 23.01,
        "lane": "right",
        "x": 0.09,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.229
      },
      {
        "time": 23.24,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.229
      },
      {
        "time": 23.469,
        "lane": "right",
        "x": 0.21,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.229
      },
      {
        "time": 23.698,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.229
      },
      {
        "time": 23.932,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 67,
        "vocalDuration": 0.083
      },
      {
        "time": 24.198,
        "lane": "left",
        "x": 0.21,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.255
      },
      {
        "time": 24.458,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.156
      },
      {
        "time": 25.203,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 25.458,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.104
      },
      {
        "time": 25.693,
        "lane": "left",
        "x": 0.21,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.224
      },
      {
        "time": 25.958,
        "lane": "right",
        "x": 0.58,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.24
      },
      {
        "time": 26.448,
        "lane": "left",
        "x": 0.36,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.255
      },
      {
        "time": 26.703,
        "lane": "right",
        "x": 0.48,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.255
      },
      {
        "time": 26.958,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.255
      },
      {
        "time": 27.521,
        "lane": "right",
        "x": 0.36,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.255
      },
      {
        "time": 27.776,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.255
      },
      {
        "time": 28.49,
        "lane": "right",
        "x": 0.24,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.26
      },
      {
        "time": 28.75,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.26
      },
      {
        "time": 29.016,
        "lane": "right",
        "x": 0.1,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.229
      },
      {
        "time": 29.302,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.227
      },
      {
        "time": 29.53,
        "lane": "right",
        "x": 0.24,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.227
      },
      {
        "time": 29.757,
        "lane": "left",
        "x": 0.36,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.227
      },
      {
        "time": 30.719,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.26
      },
      {
        "time": 30.979,
        "lane": "left",
        "x": 0.24,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 31.224,
        "lane": "right",
        "x": 0.48,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 31.469,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 31.714,
        "lane": "right",
        "x": 0.6,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 31.958,
        "lane": "left",
        "x": 0.24,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 32.203,
        "lane": "right",
        "x": 0.6,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 32.448,
        "lane": "left",
        "x": 0.36,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 32.698,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.13
      },
      {
        "time": 32.865,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.115
      },
      {
        "time": 33.448,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.089
      },
      {
        "time": 33.672,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.224
      },
      {
        "time": 33.953,
        "lane": "right",
        "x": 0.22,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.167
      },
      {
        "time": 34.453,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.292
      },
      {
        "time": 34.745,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.292
      },
      {
        "time": 35.042,
        "lane": "left",
        "x": 0.44,
        "type": "iceCream",
        "pitch": 62,
        "vocalDuration": 0.276
      },
      {
        "time": 35.484,
        "lane": "right",
        "x": 0.23,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.279
      },
      {
        "time": 35.763,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.279
      },
      {
        "time": 36.453,
        "lane": "right",
        "x": 0.36,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 36.698,
        "lane": "left",
        "x": 0.24,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.245
      },
      {
        "time": 36.953,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.266
      },
      {
        "time": 37.219,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.238
      },
      {
        "time": 37.457,
        "lane": "right",
        "x": 0.6,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.238
      },
      {
        "time": 37.694,
        "lane": "left",
        "x": 0.24,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.238
      },
      {
        "time": 38.427,
        "lane": "right",
        "x": 0.62,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.177
      },
      {
        "time": 38.661,
        "lane": "left",
        "x": 0.35,
        "type": "candy",
        "pitch": 67,
        "vocalDuration": 0.26
      },
      {
        "time": 38.922,
        "lane": "right",
        "x": 0.48,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 39.145,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 39.368,
        "lane": "right",
        "x": 0.36,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 39.592,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 39.815,
        "lane": "right",
        "x": 0.24,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 40.038,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 40.261,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.223
      },
      {
        "time": 40.484,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.193
      },
      {
        "time": 40.698,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 63,
        "vocalDuration": 0.13
      },
      {
        "time": 40.922,
        "lane": "left",
        "x": 0.34,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.297
      },
      {
        "time": 41.224,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.292
      },
      {
        "time": 41.708,
        "lane": "left",
        "x": 0.24,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.243
      },
      {
        "time": 41.951,
        "lane": "right",
        "x": 0.48,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.243
      },
      {
        "time": 42.194,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.243
      },
      {
        "time": 42.464,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 72,
        "vocalDuration": 0.177
      },
      {
        "time": 42.646,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.299
      },
      {
        "time": 42.945,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.299
      },
      {
        "time": 43.307,
        "lane": "left",
        "x": 0.39,
        "type": "candy",
        "pitch": 74,
        "vocalDuration": 0.245
      },
      {
        "time": 43.557,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.24
      },
      {
        "time": 43.797,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.24
      },
      {
        "time": 44.036,
        "lane": "right",
        "x": 0.38,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.24
      },
      {
        "time": 44.276,
        "lane": "left",
        "x": 0.63,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.24
      },
      {
        "time": 44.521,
        "lane": "right",
        "x": 0.23,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.245
      },
      {
        "time": 44.766,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.245
      },
      {
        "time": 45.01,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.245
      },
      {
        "time": 45.255,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.245
      },
      {
        "time": 45.505,
        "lane": "right",
        "x": 0.24,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.224
      },
      {
        "time": 45.729,
        "lane": "left",
        "x": 0.36,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.224
      },
      {
        "time": 45.99,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.339
      },
      {
        "time": 46.49,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.156
      },
      {
        "time": 46.646,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.212
      },
      {
        "time": 46.858,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.212
      },
      {
        "time": 47.069,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.212
      },
      {
        "time": 47.281,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 47.521,
        "lane": "right",
        "x": 0.62,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 47.76,
        "lane": "left",
        "x": 0.37,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 48,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 48.24,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 48.479,
        "lane": "right",
        "x": 0.36,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.25
      },
      {
        "time": 48.729,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.25
      },
      {
        "time": 48.979,
        "lane": "right",
        "x": 0.24,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.25
      },
      {
        "time": 49.229,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.25
      },
      {
        "time": 49.484,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.141
      },
      {
        "time": 49.625,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.151
      },
      {
        "time": 49.776,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.214
      },
      {
        "time": 49.99,
        "lane": "left",
        "x": 0.37,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.214
      },
      {
        "time": 50.203,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.214
      },
      {
        "time": 50.479,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 72,
        "vocalDuration": 0.146
      },
      {
        "time": 50.63,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 74,
        "vocalDuration": 0.281
      },
      {
        "time": 50.911,
        "lane": "left",
        "x": 0.15,
        "type": "iceCream",
        "pitch": 74,
        "vocalDuration": 0.281
      },
      {
        "time": 51.229,
        "lane": "right",
        "x": 0.64,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.068
      },
      {
        "time": 51.297,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.141
      },
      {
        "time": 51.443,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 51.698,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 51.953,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 52.208,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 52.469,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.251
      },
      {
        "time": 52.72,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.251
      },
      {
        "time": 52.971,
        "lane": "right",
        "x": 0.23,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.251
      },
      {
        "time": 53.223,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.251
      },
      {
        "time": 53.474,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.227
      },
      {
        "time": 53.701,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.227
      },
      {
        "time": 53.953,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.161
      },
      {
        "time": 54.12,
        "lane": "left",
        "x": 0.37,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.068
      },
      {
        "time": 54.474,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 72,
        "vocalDuration": 0.266
      },
      {
        "time": 54.745,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.232
      },
      {
        "time": 54.977,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.232
      },
      {
        "time": 55.208,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.232
      },
      {
        "time": 55.44,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.232
      },
      {
        "time": 55.677,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.281
      },
      {
        "time": 55.964,
        "lane": "right",
        "x": 0.6,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.219
      },
      {
        "time": 56.182,
        "lane": "left",
        "x": 0.36,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.219
      },
      {
        "time": 56.432,
        "lane": "right",
        "x": 0.53,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.281
      },
      {
        "time": 56.969,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.224
      },
      {
        "time": 57.198,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.264
      },
      {
        "time": 57.462,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.264
      },
      {
        "time": 57.726,
        "lane": "right",
        "x": 0.23,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.264
      },
      {
        "time": 58,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.211
      },
      {
        "time": 58.211,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.211
      },
      {
        "time": 58.453,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.115
      },
      {
        "time": 58.714,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.135
      },
      {
        "time": 58.859,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 59.078,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 59.297,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 59.516,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 59.734,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 59.958,
        "lane": "right",
        "x": 0.59,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.115
      },
      {
        "time": 60.411,
        "lane": "left",
        "x": 0.21,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.068
      },
      {
        "time": 60.479,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 60.708,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 60.943,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 61.193,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 61.443,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 61.693,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 61.943,
        "lane": "right",
        "x": 0.22,
        "type": "cupcake",
        "pitch": 67,
        "vocalDuration": 0.141
      },
      {
        "time": 62.089,
        "lane": "left",
        "x": 0.55,
        "type": "candy",
        "pitch": 61,
        "vocalDuration": 0.115
      },
      {
        "time": 62.427,
        "lane": "right",
        "x": 0.09,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.068
      },
      {
        "time": 62.5,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.242
      },
      {
        "time": 62.742,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.242
      },
      {
        "time": 62.984,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.242
      },
      {
        "time": 63.227,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.242
      },
      {
        "time": 63.469,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.242
      },
      {
        "time": 63.711,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.242
      },
      {
        "time": 63.958,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.094
      },
      {
        "time": 64.484,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.151
      },
      {
        "time": 65.135,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.094
      },
      {
        "time": 65.229,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.151
      },
      {
        "time": 65.729,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.234
      },
      {
        "time": 65.979,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.141
      },
      {
        "time": 66.13,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 67,
        "vocalDuration": 0.13
      },
      {
        "time": 66.458,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 66.708,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 66.958,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 67.208,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 67.458,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 67.708,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 67.964,
        "lane": "right",
        "x": 0.23,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.125
      },
      {
        "time": 68.49,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.23
      },
      {
        "time": 68.72,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.23
      },
      {
        "time": 68.951,
        "lane": "left",
        "x": 0.21,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.23
      },
      {
        "time": 69.181,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.23
      },
      {
        "time": 69.411,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.125
      },
      {
        "time": 69.542,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.141
      },
      {
        "time": 69.682,
        "lane": "left",
        "x": 0.21,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.276
      },
      {
        "time": 69.958,
        "lane": "right",
        "x": 0.6,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.078
      },
      {
        "time": 70.406,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.125
      },
      {
        "time": 70.536,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.255
      },
      {
        "time": 70.797,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.227
      },
      {
        "time": 71.024,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.227
      },
      {
        "time": 71.251,
        "lane": "left",
        "x": 0.58,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.227
      },
      {
        "time": 71.478,
        "lane": "right",
        "x": 0.21,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.227
      },
      {
        "time": 71.705,
        "lane": "left",
        "x": 0.58,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.227
      },
      {
        "time": 71.938,
        "lane": "right",
        "x": 0.1,
        "type": "sushi",
        "pitch": 67,
        "vocalDuration": 0.073
      },
      {
        "time": 72.182,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.232
      },
      {
        "time": 72.414,
        "lane": "right",
        "x": 0.21,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.232
      },
      {
        "time": 73.193,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 73.448,
        "lane": "right",
        "x": 0.34,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.125
      },
      {
        "time": 73.573,
        "lane": "left",
        "x": 0.22,
        "type": "candy",
        "pitch": 67,
        "vocalDuration": 0.125
      },
      {
        "time": 73.979,
        "lane": "right",
        "x": 0.47,
        "type": "sushi",
        "pitch": 67,
        "vocalDuration": 0.24
      },
      {
        "time": 74.224,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 74.448,
        "lane": "right",
        "x": 0.6,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 74.672,
        "lane": "left",
        "x": 0.23,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 74.896,
        "lane": "right",
        "x": 0.6,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 75.49,
        "lane": "left",
        "x": 0.35,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.253
      },
      {
        "time": 75.742,
        "lane": "right",
        "x": 0.47,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.253
      },
      {
        "time": 76,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 67,
        "vocalDuration": 0.214
      },
      {
        "time": 76.266,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.135
      },
      {
        "time": 76.474,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.253
      },
      {
        "time": 76.727,
        "lane": "right",
        "x": 0.23,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.253
      },
      {
        "time": 76.984,
        "lane": "left",
        "x": 0.58,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.208
      },
      {
        "time": 77.505,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 62,
        "vocalDuration": 0.234
      },
      {
        "time": 77.745,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.141
      },
      {
        "time": 78.484,
        "lane": "right",
        "x": 0.24,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.323
      },
      {
        "time": 78.813,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.12
      },
      {
        "time": 78.948,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 79.2,
        "lane": "left",
        "x": 0.23,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 79.452,
        "lane": "right",
        "x": 0.47,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 79.704,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 79.956,
        "lane": "right",
        "x": 0.6,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 80.208,
        "lane": "left",
        "x": 0.24,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.281
      },
      {
        "time": 80.49,
        "lane": "right",
        "x": 0.6,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.349
      },
      {
        "time": 80.844,
        "lane": "left",
        "x": 0.32,
        "type": "candy",
        "pitch": 63,
        "vocalDuration": 0.266
      },
      {
        "time": 81.182,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.193
      },
      {
        "time": 81.38,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.089
      },
      {
        "time": 81.474,
        "lane": "right",
        "x": 0.34,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.109
      },
      {
        "time": 81.682,
        "lane": "left",
        "x": 0.6,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.271
      },
      {
        "time": 81.958,
        "lane": "right",
        "x": 0.23,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.263
      },
      {
        "time": 82.221,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.263
      },
      {
        "time": 82.49,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.211
      },
      {
        "time": 82.701,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.211
      },
      {
        "time": 82.932,
        "lane": "right",
        "x": 0.21,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.073
      },
      {
        "time": 83.005,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.266
      },
      {
        "time": 83.271,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.266
      },
      {
        "time": 83.536,
        "lane": "left",
        "x": 0.23,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.266
      },
      {
        "time": 83.958,
        "lane": "right",
        "x": 0.47,
        "type": "sushi",
        "pitch": 67,
        "vocalDuration": 0.229
      },
      {
        "time": 84.188,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.188
      },
      {
        "time": 84.385,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.083
      },
      {
        "time": 84.474,
        "lane": "left",
        "x": 0.23,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.245
      },
      {
        "time": 84.724,
        "lane": "right",
        "x": 0.6,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.245
      },
      {
        "time": 84.979,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.214
      },
      {
        "time": 85.198,
        "lane": "right",
        "x": 0.47,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.258
      },
      {
        "time": 85.456,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.258
      },
      {
        "time": 85.719,
        "lane": "right",
        "x": 0.36,
        "type": "fish",
        "pitch": 69,
        "vocalDuration": 0.089
      },
      {
        "time": 85.896,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.161
      },
      {
        "time": 86.943,
        "lane": "right",
        "x": 0.23,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.247
      },
      {
        "time": 87.189,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.247
      },
      {
        "time": 87.436,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.247
      },
      {
        "time": 87.682,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.247
      },
      {
        "time": 87.929,
        "lane": "right",
        "x": 0.23,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.247
      },
      {
        "time": 88.175,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.247
      },
      {
        "time": 88.422,
        "lane": "right",
        "x": 0.34,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.089
      },
      {
        "time": 88.516,
        "lane": "left",
        "x": 0.24,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.161
      },
      {
        "time": 88.688,
        "lane": "right",
        "x": 0.44,
        "type": "sushi",
        "pitch": 62,
        "vocalDuration": 0.13
      },
      {
        "time": 88.901,
        "lane": "left",
        "x": 0.11,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.234
      },
      {
        "time": 89.224,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.229
      },
      {
        "time": 89.453,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.229
      },
      {
        "time": 89.688,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.248
      },
      {
        "time": 89.936,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.248
      },
      {
        "time": 90.184,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.248
      },
      {
        "time": 90.443,
        "lane": "left",
        "x": 0.5,
        "type": "iceCream",
        "pitch": 72,
        "vocalDuration": 0.203
      },
      {
        "time": 90.646,
        "lane": "right",
        "x": 0.39,
        "type": "fish",
        "pitch": 74,
        "vocalDuration": 0.214
      },
      {
        "time": 90.859,
        "lane": "left",
        "x": 0.64,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.214
      },
      {
        "time": 91.073,
        "lane": "right",
        "x": 0.27,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.214
      },
      {
        "time": 91.286,
        "lane": "left",
        "x": 0.64,
        "type": "candy",
        "pitch": 74,
        "vocalDuration": 0.214
      },
      {
        "time": 91.505,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.242
      },
      {
        "time": 91.747,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.242
      },
      {
        "time": 91.99,
        "lane": "right",
        "x": 0.28,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.242
      },
      {
        "time": 92.232,
        "lane": "left",
        "x": 0.4,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.242
      },
      {
        "time": 92.479,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.243
      },
      {
        "time": 92.723,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.243
      },
      {
        "time": 92.966,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.243
      },
      {
        "time": 93.21,
        "lane": "left",
        "x": 0.13,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.243
      },
      {
        "time": 93.458,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.258
      },
      {
        "time": 93.716,
        "lane": "left",
        "x": 0.26,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.258
      },
      {
        "time": 93.979,
        "lane": "right",
        "x": 0.62,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.333
      },
      {
        "time": 94.458,
        "lane": "left",
        "x": 0.39,
        "type": "candy",
        "pitch": 74,
        "vocalDuration": 0.172
      },
      {
        "time": 94.635,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.292
      },
      {
        "time": 94.927,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.292
      },
      {
        "time": 95.224,
        "lane": "right",
        "x": 0.38,
        "type": "fish",
        "pitch": 72,
        "vocalDuration": 0.266
      },
      {
        "time": 95.49,
        "lane": "left",
        "x": 0.64,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.219
      },
      {
        "time": 95.708,
        "lane": "right",
        "x": 0.25,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.26
      },
      {
        "time": 95.969,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.26
      },
      {
        "time": 96.229,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.26
      },
      {
        "time": 96.49,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.26
      },
      {
        "time": 96.75,
        "lane": "right",
        "x": 0.26,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.233
      },
      {
        "time": 96.983,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.233
      },
      {
        "time": 97.215,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.233
      },
      {
        "time": 97.458,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.135
      },
      {
        "time": 97.635,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.172
      },
      {
        "time": 97.813,
        "lane": "left",
        "x": 0.13,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.156
      },
      {
        "time": 98.422,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.172
      },
      {
        "time": 98.599,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.224
      },
      {
        "time": 98.823,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.224
      },
      {
        "time": 99.047,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.156
      },
      {
        "time": 99.203,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.297
      },
      {
        "time": 99.5,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 99.746,
        "lane": "right",
        "x": 0.4,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 99.992,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 100.238,
        "lane": "right",
        "x": 0.28,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 100.484,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.161
      },
      {
        "time": 100.646,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.267
      },
      {
        "time": 100.913,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.267
      },
      {
        "time": 101.181,
        "lane": "right",
        "x": 0.23,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.267
      },
      {
        "time": 101.448,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.253
      },
      {
        "time": 101.701,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.253
      },
      {
        "time": 101.964,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 102.458,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.25
      },
      {
        "time": 102.714,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.242
      },
      {
        "time": 102.956,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.242
      },
      {
        "time": 103.198,
        "lane": "left",
        "x": 0.26,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.242
      },
      {
        "time": 103.44,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.242
      },
      {
        "time": 103.688,
        "lane": "left",
        "x": 0.39,
        "type": "candy",
        "pitch": 74,
        "vocalDuration": 0.276
      },
      {
        "time": 103.969,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.375
      },
      {
        "time": 104.406,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 81,
        "vocalDuration": 0.234
      },
      {
        "time": 104.885,
        "lane": "right",
        "x": 0.38,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.313
      },
      {
        "time": 105.198,
        "lane": "left",
        "x": 0.62,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.25
      },
      {
        "time": 105.448,
        "lane": "right",
        "x": 0.25,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.25
      },
      {
        "time": 105.698,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.25
      },
      {
        "time": 106,
        "lane": "right",
        "x": 0.14,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.365
      },
      {
        "time": 106.464,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.125
      },
      {
        "time": 106.708,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.234
      },
      {
        "time": 106.943,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.234
      },
      {
        "time": 107.208,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.203
      },
      {
        "time": 107.411,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.203
      },
      {
        "time": 107.615,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.203
      },
      {
        "time": 108.089,
        "lane": "left",
        "x": 0.09,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.177
      },
      {
        "time": 108.286,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.161
      },
      {
        "time": 108.49,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 108.74,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 108.99,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 109.24,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 109.49,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 109.74,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 110.516,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.215
      },
      {
        "time": 110.73,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.215
      },
      {
        "time": 110.945,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.215
      },
      {
        "time": 111.16,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.215
      },
      {
        "time": 111.375,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.318
      },
      {
        "time": 111.693,
        "lane": "right",
        "x": 0.21,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.25
      },
      {
        "time": 111.964,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.073
      },
      {
        "time": 112.38,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.094
      },
      {
        "time": 112.479,
        "lane": "left",
        "x": 0.22,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.135
      },
      {
        "time": 112.615,
        "lane": "right",
        "x": 0.44,
        "type": "sushi",
        "pitch": 63,
        "vocalDuration": 0.083
      },
      {
        "time": 112.885,
        "lane": "left",
        "x": 0.25,
        "type": "iceCream",
        "pitch": 90,
        "vocalDuration": 0.302
      },
      {
        "time": 113.208,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.167
      },
      {
        "time": 113.5,
        "lane": "left",
        "x": 0.22,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.078
      },
      {
        "time": 113.714,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.255
      },
      {
        "time": 113.979,
        "lane": "left",
        "x": 0.34,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.234
      },
      {
        "time": 114.458,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 114.688,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 114.917,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 115.146,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 115.375,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 115.604,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 116.089,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 61,
        "vocalDuration": 0.13
      },
      {
        "time": 117.552,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.206
      },
      {
        "time": 117.758,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.206
      },
      {
        "time": 117.964,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 67,
        "vocalDuration": 0.083
      },
      {
        "time": 118.552,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 118.781,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 119.01,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 119.24,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 119.469,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 119.698,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 119.932,
        "lane": "right",
        "x": 0.59,
        "type": "cupcake",
        "pitch": 67,
        "vocalDuration": 0.141
      },
      {
        "time": 120.49,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.167
      },
      {
        "time": 121.161,
        "lane": "right",
        "x": 0.44,
        "type": "sushi",
        "pitch": 63,
        "vocalDuration": 0.229
      },
      {
        "time": 121.464,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.167
      },
      {
        "time": 121.693,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.125
      },
      {
        "time": 121.922,
        "lane": "left",
        "x": 0.58,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.271
      },
      {
        "time": 123.74,
        "lane": "right",
        "x": 0.21,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.146
      },
      {
        "time": 123.885,
        "lane": "left",
        "x": 0.6,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.26
      },
      {
        "time": 124.151,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.141
      },
      {
        "time": 124.292,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.234
      },
      {
        "time": 124.531,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.172
      },
      {
        "time": 125.672,
        "lane": "left",
        "x": 0.37,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.216
      },
      {
        "time": 125.888,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.216
      },
      {
        "time": 126.177,
        "lane": "left",
        "x": 0.24,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.146
      },
      {
        "time": 126.323,
        "lane": "right",
        "x": 0.47,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.307
      },
      {
        "time": 126.641,
        "lane": "left",
        "x": 0.13,
        "type": "iceCream",
        "pitch": 72,
        "vocalDuration": 0.26
      },
      {
        "time": 127.651,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.151
      },
      {
        "time": 127.802,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.13
      },
      {
        "time": 127.932,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.232
      },
      {
        "time": 128.164,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.232
      },
      {
        "time": 128.401,
        "lane": "right",
        "x": 0.53,
        "type": "sushi",
        "pitch": 77,
        "vocalDuration": 0.156
      },
      {
        "time": 128.688,
        "lane": "left",
        "x": 0.48,
        "type": "iceCream",
        "pitch": 69,
        "vocalDuration": 0.13
      },
      {
        "time": 129.948,
        "lane": "right",
        "x": 0.49,
        "type": "fish",
        "pitch": 89,
        "vocalDuration": 0.24
      },
      {
        "time": 130.49,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.115
      },
      {
        "time": 130.62,
        "lane": "right",
        "x": 0.29,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.12
      },
      {
        "time": 130.745,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.219
      },
      {
        "time": 131.021,
        "lane": "right",
        "x": 0.17,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.188
      },
      {
        "time": 131.214,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.215
      },
      {
        "time": 131.429,
        "lane": "right",
        "x": 0.28,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.215
      },
      {
        "time": 131.644,
        "lane": "left",
        "x": 0.4,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.215
      },
      {
        "time": 131.943,
        "lane": "right",
        "x": 0.42,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.182
      },
      {
        "time": 132.182,
        "lane": "left",
        "x": 0.28,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.25
      },
      {
        "time": 132.49,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.177
      },
      {
        "time": 132.667,
        "lane": "left",
        "x": 0.16,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.286
      },
      {
        "time": 133.01,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.089
      },
      {
        "time": 133.208,
        "lane": "left",
        "x": 0.28,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.248
      },
      {
        "time": 133.457,
        "lane": "right",
        "x": 0.65,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.248
      },
      {
        "time": 133.705,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.248
      },
      {
        "time": 133.958,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.215
      },
      {
        "time": 134.174,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.215
      },
      {
        "time": 134.389,
        "lane": "right",
        "x": 0.38,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.215
      },
      {
        "time": 134.609,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 134.842,
        "lane": "right",
        "x": 0.28,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 135.074,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 135.307,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 135.539,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 135.771,
        "lane": "right",
        "x": 0.28,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 136.004,
        "lane": "left",
        "x": 0.4,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 136.236,
        "lane": "right",
        "x": 0.4,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.232
      },
      {
        "time": 136.474,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 136.704,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 136.934,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 137.164,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 137.394,
        "lane": "left",
        "x": 0.26,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 137.624,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 137.853,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.23
      },
      {
        "time": 138.474,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 138.724,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.234
      },
      {
        "time": 139,
        "lane": "right",
        "x": 0.42,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.276
      },
      {
        "time": 139.286,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.193
      },
      {
        "time": 139.505,
        "lane": "right",
        "x": 0.29,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.232
      },
      {
        "time": 139.737,
        "lane": "left",
        "x": 0.66,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.232
      },
      {
        "time": 139.974,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.276
      },
      {
        "time": 140.281,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.219
      },
      {
        "time": 141.146,
        "lane": "right",
        "x": 0.28,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.286
      },
      {
        "time": 141.432,
        "lane": "left",
        "x": 0.4,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.286
      },
      {
        "time": 141.719,
        "lane": "right",
        "x": 0.4,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.266
      },
      {
        "time": 141.984,
        "lane": "left",
        "x": 0.28,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.266
      },
      {
        "time": 142.255,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.333
      },
      {
        "time": 142.594,
        "lane": "left",
        "x": 0.16,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 142.822,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 143.051,
        "lane": "left",
        "x": 0.28,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 143.279,
        "lane": "right",
        "x": 0.65,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 143.508,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 143.736,
        "lane": "right",
        "x": 0.53,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 143.965,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 144.193,
        "lane": "right",
        "x": 0.4,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.229
      },
      {
        "time": 144.427,
        "lane": "left",
        "x": 0.63,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 144.682,
        "lane": "right",
        "x": 0.26,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 144.938,
        "lane": "left",
        "x": 0.63,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 145.193,
        "lane": "right",
        "x": 0.14,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 145.448,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 145.703,
        "lane": "right",
        "x": 0.26,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 146.469,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.224
      },
      {
        "time": 146.693,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.302
      },
      {
        "time": 146.995,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.224
      },
      {
        "time": 147.224,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 147.464,
        "lane": "left",
        "x": 0.13,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 147.948,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.245
      },
      {
        "time": 148.193,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.271
      },
      {
        "time": 148.469,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.203
      },
      {
        "time": 148.677,
        "lane": "left",
        "x": 0.37,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 148.908,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 149.138,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 149.368,
        "lane": "right",
        "x": 0.37,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 149.599,
        "lane": "left",
        "x": 0.62,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 149.829,
        "lane": "right",
        "x": 0.25,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 150.06,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 150.29,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.23
      },
      {
        "time": 150.615,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 150.843,
        "lane": "right",
        "x": 0.26,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 151.072,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 151.3,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 151.529,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 151.757,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 151.986,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 152.214,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.229
      },
      {
        "time": 152.448,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.146
      },
      {
        "time": 152.599,
        "lane": "right",
        "x": 0.61,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.247
      },
      {
        "time": 152.845,
        "lane": "left",
        "x": 0.37,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.247
      },
      {
        "time": 153.092,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.247
      },
      {
        "time": 153.339,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.247
      },
      {
        "time": 153.585,
        "lane": "right",
        "x": 0.37,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.247
      },
      {
        "time": 153.832,
        "lane": "left",
        "x": 0.61,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.247
      },
      {
        "time": 154.323,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.073
      },
      {
        "time": 154.484,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 72,
        "vocalDuration": 0.242
      },
      {
        "time": 154.727,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 72,
        "vocalDuration": 0.242
      },
      {
        "time": 154.969,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.25
      },
      {
        "time": 155.219,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.276
      },
      {
        "time": 155.495,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.245
      },
      {
        "time": 155.74,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.245
      },
      {
        "time": 155.984,
        "lane": "left",
        "x": 0.28,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.208
      },
      {
        "time": 157.151,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.226
      },
      {
        "time": 157.377,
        "lane": "left",
        "x": 0.13,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.226
      },
      {
        "time": 157.603,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.226
      },
      {
        "time": 157.829,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.226
      },
      {
        "time": 158.055,
        "lane": "right",
        "x": 0.62,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.226
      },
      {
        "time": 158.281,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.219
      },
      {
        "time": 158.5,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.172
      },
      {
        "time": 158.672,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.271
      },
      {
        "time": 158.943,
        "lane": "right",
        "x": 0.37,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.271
      },
      {
        "time": 159.219,
        "lane": "left",
        "x": 0.61,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.182
      },
      {
        "time": 159.406,
        "lane": "right",
        "x": 0.25,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 159.643,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 159.879,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 160.116,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 160.352,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 160.589,
        "lane": "left",
        "x": 0.37,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 160.826,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 161.062,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 161.299,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 161.535,
        "lane": "left",
        "x": 0.13,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 161.772,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 162.008,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 162.292,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.156
      },
      {
        "time": 162.51,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.146
      },
      {
        "time": 162.661,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 74,
        "vocalDuration": 0.205
      },
      {
        "time": 162.866,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 74,
        "vocalDuration": 0.205
      },
      {
        "time": 163.071,
        "lane": "right",
        "x": 0.39,
        "type": "fish",
        "pitch": 74,
        "vocalDuration": 0.205
      },
      {
        "time": 163.276,
        "lane": "left",
        "x": 0.63,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.208
      },
      {
        "time": 163.484,
        "lane": "right",
        "x": 0.28,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.254
      },
      {
        "time": 163.738,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.254
      },
      {
        "time": 163.992,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.254
      },
      {
        "time": 164.246,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.254
      },
      {
        "time": 164.552,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.242
      },
      {
        "time": 164.794,
        "lane": "left",
        "x": 0.37,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.242
      },
      {
        "time": 165.036,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.242
      },
      {
        "time": 165.279,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.242
      },
      {
        "time": 165.521,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.227
      },
      {
        "time": 165.747,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.227
      },
      {
        "time": 166,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.208
      },
      {
        "time": 166.281,
        "lane": "left",
        "x": 0.24,
        "type": "donut",
        "pitch": 69,
        "vocalDuration": 0.188
      },
      {
        "time": 166.49,
        "lane": "right",
        "x": 0.62,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.224
      },
      {
        "time": 166.719,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.258
      },
      {
        "time": 166.977,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.258
      },
      {
        "time": 167.24,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.276
      },
      {
        "time": 167.516,
        "lane": "right",
        "x": 0.39,
        "type": "fish",
        "pitch": 74,
        "vocalDuration": 0.219
      },
      {
        "time": 167.734,
        "lane": "left",
        "x": 0.62,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.264
      },
      {
        "time": 167.998,
        "lane": "right",
        "x": 0.25,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.264
      },
      {
        "time": 168.262,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.264
      },
      {
        "time": 168.526,
        "lane": "right",
        "x": 0.14,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.236
      },
      {
        "time": 168.762,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.236
      },
      {
        "time": 168.997,
        "lane": "right",
        "x": 0.26,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.236
      },
      {
        "time": 169.233,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.236
      },
      {
        "time": 169.5,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.12
      },
      {
        "time": 169.656,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.193
      },
      {
        "time": 169.854,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.156
      },
      {
        "time": 170.464,
        "lane": "left",
        "x": 0.15,
        "type": "iceCream",
        "pitch": 74,
        "vocalDuration": 0.135
      },
      {
        "time": 170.604,
        "lane": "right",
        "x": 0.64,
        "type": "fish",
        "pitch": 74,
        "vocalDuration": 0.21
      },
      {
        "time": 170.814,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 74,
        "vocalDuration": 0.21
      },
      {
        "time": 171.024,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.21
      },
      {
        "time": 171.24,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.292
      },
      {
        "time": 171.531,
        "lane": "right",
        "x": 0.53,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 171.777,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 172.023,
        "lane": "right",
        "x": 0.4,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 172.27,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.246
      },
      {
        "time": 172.531,
        "lane": "right",
        "x": 0.25,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.247
      },
      {
        "time": 172.779,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.247
      },
      {
        "time": 173.026,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.247
      },
      {
        "time": 173.273,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.247
      },
      {
        "time": 173.521,
        "lane": "right",
        "x": 0.26,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 173.776,
        "lane": "left",
        "x": 0.38,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.255
      },
      {
        "time": 174.036,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.219
      },
      {
        "time": 174.5,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.26
      },
      {
        "time": 174.76,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.245
      },
      {
        "time": 175.005,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.245
      },
      {
        "time": 175.25,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.234
      },
      {
        "time": 175.484,
        "lane": "left",
        "x": 0.28,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.234
      },
      {
        "time": 175.719,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.281
      },
      {
        "time": 176,
        "lane": "left",
        "x": 0.38,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.198
      },
      {
        "time": 176.198,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.198
      },
      {
        "time": 176.443,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 81,
        "vocalDuration": 0.237
      },
      {
        "time": 176.68,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 81,
        "vocalDuration": 0.237
      },
      {
        "time": 176.917,
        "lane": "left",
        "x": 0.63,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.05
      },
      {
        "time": 176.917,
        "lane": "right",
        "x": 0.32,
        "type": "cupcake",
        "pitch": 82,
        "vocalDuration": 0.266
      },
      {
        "time": 177.182,
        "lane": "left",
        "x": 0.62,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.264
      },
      {
        "time": 177.446,
        "lane": "right",
        "x": 0.13,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.264
      },
      {
        "time": 177.71,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.264
      },
      {
        "time": 178.036,
        "lane": "right",
        "x": 0.26,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.333
      },
      {
        "time": 178.474,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.156
      },
      {
        "time": 178.745,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.094
      },
      {
        "time": 178.839,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.228
      },
      {
        "time": 179.067,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.228
      },
      {
        "time": 179.295,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.228
      },
      {
        "time": 179.523,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.228
      },
      {
        "time": 179.751,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.228
      },
      {
        "time": 180.5,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 180.797,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.243
      },
      {
        "time": 181.04,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.243
      },
      {
        "time": 181.282,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.243
      },
      {
        "time": 181.525,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.243
      },
      {
        "time": 181.768,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.243
      },
      {
        "time": 182.521,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.255
      },
      {
        "time": 182.776,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.255
      },
      {
        "time": 183.036,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.236
      },
      {
        "time": 183.272,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.236
      },
      {
        "time": 183.508,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.236
      },
      {
        "time": 183.743,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.236
      },
      {
        "time": 184.182,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.156
      },
      {
        "time": 184.344,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.13
      },
      {
        "time": 184.479,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.135
      },
      {
        "time": 184.615,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.094
      },
      {
        "time": 184.792,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.135
      },
      {
        "time": 185.021,
        "lane": "left",
        "x": 0.21,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.203
      },
      {
        "time": 185.229,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 185.495,
        "lane": "left",
        "x": 0.34,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.125
      },
      {
        "time": 185.74,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 185.974,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.172
      },
      {
        "time": 186.474,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.241
      },
      {
        "time": 186.715,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.241
      },
      {
        "time": 186.957,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.241
      },
      {
        "time": 187.198,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.241
      },
      {
        "time": 187.439,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.241
      },
      {
        "time": 187.681,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.241
      },
      {
        "time": 188.016,
        "lane": "right",
        "x": 0.22,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.094
      },
      {
        "time": 188.115,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 62,
        "vocalDuration": 0.104
      },
      {
        "time": 188.51,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 188.75,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 188.99,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 189.229,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 189.469,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 189.708,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.24
      },
      {
        "time": 190.547,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.258
      },
      {
        "time": 190.805,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.258
      },
      {
        "time": 191.063,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.258
      },
      {
        "time": 191.32,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.258
      },
      {
        "time": 191.578,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.258
      },
      {
        "time": 191.836,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.258
      },
      {
        "time": 192.464,
        "lane": "right",
        "x": 0.27,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.115
      },
      {
        "time": 192.583,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.255
      },
      {
        "time": 192.953,
        "lane": "right",
        "x": 0.11,
        "type": "sushi",
        "pitch": 69,
        "vocalDuration": 0.224
      },
      {
        "time": 193.177,
        "lane": "left",
        "x": 0.47,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.259
      },
      {
        "time": 193.436,
        "lane": "right",
        "x": 0.23,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.259
      },
      {
        "time": 193.694,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.259
      },
      {
        "time": 193.958,
        "lane": "right",
        "x": 0.36,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.193
      },
      {
        "time": 194.151,
        "lane": "left",
        "x": 0.24,
        "type": "candy",
        "pitch": 69,
        "vocalDuration": 0.193
      },
      {
        "time": 194.479,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.161
      },
      {
        "time": 194.74,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.248
      },
      {
        "time": 194.988,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.248
      },
      {
        "time": 195.235,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.248
      },
      {
        "time": 195.483,
        "lane": "right",
        "x": 0.57,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.248
      },
      {
        "time": 195.731,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.248
      },
      {
        "time": 196.219,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.078
      },
      {
        "time": 196.302,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.182
      },
      {
        "time": 196.505,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 196.755,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 197.005,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 197.255,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 197.505,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 197.755,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.25
      },
      {
        "time": 198.01,
        "lane": "right",
        "x": 0.22,
        "type": "fish",
        "pitch": 67,
        "vocalDuration": 0.094
      },
      {
        "time": 198.516,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 198.734,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 198.953,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 199.172,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.219
      },
      {
        "time": 199.391,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.201
      },
      {
        "time": 199.592,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.201
      },
      {
        "time": 199.793,
        "lane": "left",
        "x": 0.2,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.201
      },
      {
        "time": 200.479,
        "lane": "right",
        "x": 0.58,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.135
      },
      {
        "time": 200.62,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 62,
        "vocalDuration": 0.104
      },
      {
        "time": 200.786,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.089
      },
      {
        "time": 200.938,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.109
      },
      {
        "time": 201.047,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.135
      },
      {
        "time": 201.229,
        "lane": "left",
        "x": 0.57,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.125
      },
      {
        "time": 201.526,
        "lane": "right",
        "x": 0.22,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.177
      },
      {
        "time": 201.745,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 201.979,
        "lane": "right",
        "x": 0.1,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.156
      },
      {
        "time": 202.625,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.22
      },
      {
        "time": 202.845,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.22
      },
      {
        "time": 203.064,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.22
      },
      {
        "time": 203.284,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.22
      },
      {
        "time": 203.503,
        "lane": "left",
        "x": 0.2,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.22
      },
      {
        "time": 203.723,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.22
      },
      {
        "time": 204.109,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 63,
        "vocalDuration": 0.063
      },
      {
        "time": 204.313,
        "lane": "right",
        "x": 0.58,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.177
      },
      {
        "time": 204.51,
        "lane": "left",
        "x": 0.21,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.246
      },
      {
        "time": 204.756,
        "lane": "right",
        "x": 0.58,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.246
      },
      {
        "time": 205.002,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.246
      },
      {
        "time": 205.247,
        "lane": "right",
        "x": 0.46,
        "type": "sushi",
        "pitch": 65,
        "vocalDuration": 0.246
      },
      {
        "time": 205.493,
        "lane": "left",
        "x": 0.46,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.246
      },
      {
        "time": 205.739,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 65,
        "vocalDuration": 0.246
      },
      {
        "time": 206.359,
        "lane": "left",
        "x": 0.58,
        "type": "donut",
        "pitch": 65,
        "vocalDuration": 0.177
      },
      {
        "time": 206.542,
        "lane": "right",
        "x": 0.2,
        "type": "cupcake",
        "pitch": 64,
        "vocalDuration": 0.271
      },
      {
        "time": 206.818,
        "lane": "left",
        "x": 0.57,
        "type": "candy",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 207.047,
        "lane": "right",
        "x": 0.08,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 207.276,
        "lane": "left",
        "x": 0.45,
        "type": "iceCream",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 207.505,
        "lane": "right",
        "x": 0.2,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 207.734,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 64,
        "vocalDuration": 0.229
      },
      {
        "time": 208.297,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.073
      },
      {
        "time": 208.495,
        "lane": "left",
        "x": 0.21,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.234
      },
      {
        "time": 209.182,
        "lane": "right",
        "x": 0.45,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.188
      },
      {
        "time": 209.443,
        "lane": "left",
        "x": 0.1,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.109
      },
      {
        "time": 209.703,
        "lane": "right",
        "x": 0.57,
        "type": "fish",
        "pitch": 64,
        "vocalDuration": 0.193
      },
      {
        "time": 209.927,
        "lane": "left",
        "x": 0.22,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.193
      },
      {
        "time": 210.125,
        "lane": "right",
        "x": 0.59,
        "type": "cupcake",
        "pitch": 67,
        "vocalDuration": 0.109
      },
      {
        "time": 210.349,
        "lane": "left",
        "x": 0.34,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.276
      }
    ]
  },
  "difficultyCharts": {
    "easy": {
      "noteTravelTime": 1.9,
      "notes": [
        {
          "time": 2.464,
          "lane": "left",
          "x": 0.1,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.083
        },
        {
          "time": 2.656,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.135
        },
        {
          "time": 2.844,
          "lane": "left",
          "x": 0.18,
          "type": "donut",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.063,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.281,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.505,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.375
        },
        {
          "time": 3.917,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.292
        },
        {
          "time": 4.208,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.365
        },
        {
          "time": 4.578,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 72,
          "vocalDuration": 0.333
        },
        {
          "time": 4.943,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.149,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.356,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.563,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.203
        },
        {
          "time": 6.255,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 85,
          "vocalDuration": 0.156
        },
        {
          "time": 6.552,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 6.823,
          "lane": "right",
          "x": 0.12,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.354
        },
        {
          "time": 7.182,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.245
        },
        {
          "time": 7.443,
          "lane": "right",
          "x": 0.23,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.068
        },
        {
          "time": 8.365,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.078
        },
        {
          "time": 8.51,
          "lane": "right",
          "x": 0.27,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.099
        },
        {
          "time": 9.911,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.078
        },
        {
          "time": 10.958,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.207,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.456,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.704,
          "lane": "left",
          "x": 0.25,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.958,
          "lane": "right",
          "x": 0.49,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.12
        },
        {
          "time": 12.083,
          "lane": "left",
          "x": 0.15,
          "type": "donut",
          "pitch": 62,
          "vocalDuration": 0.089
        },
        {
          "time": 12.458,
          "lane": "right",
          "x": 0.56,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.13
        },
        {
          "time": 12.599,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.271
        },
        {
          "time": 12.901,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 12.979,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.456,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.694,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.948,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.104
        },
        {
          "time": 14.479,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 14.693,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 14.906,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 15.12,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 15.339,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.297
        },
        {
          "time": 15.635,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.297
        },
        {
          "time": 16.432,
          "lane": "right",
          "x": 0.25,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.13
        },
        {
          "time": 16.568,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.109
        },
        {
          "time": 17.229,
          "lane": "right",
          "x": 0.16,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.292
        },
        {
          "time": 17.703,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 17.974,
          "lane": "right",
          "x": 0.1,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 18.307,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.13
        },
        {
          "time": 18.438,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 18.671,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 18.904,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 19.137,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 19.38,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.146
        },
        {
          "time": 19.526,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.208
        },
        {
          "time": 19.734,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.208
        },
        {
          "time": 19.948,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.115
        },
        {
          "time": 20.469,
          "lane": "right",
          "x": 0.48,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 20.714,
          "lane": "left",
          "x": 0.08,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 20.958,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.203,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.448,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.693,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.938,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.125
        },
        {
          "time": 22.422,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.063
        },
        {
          "time": 22.49,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.286
        },
        {
          "time": 22.781,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.01,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.24,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.469,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.698,
          "lane": "left",
          "x": 0.56,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.932,
          "lane": "right",
          "x": 0.26,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.083
        },
        {
          "time": 24.198,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.255
        },
        {
          "time": 24.458,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 25.203,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 25.458,
          "lane": "right",
          "x": 0.1,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.104
        },
        {
          "time": 25.693,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.224
        },
        {
          "time": 25.958,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 26.448,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 26.703,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 26.958,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 27.521,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 27.776,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 28.49,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.26
        },
        {
          "time": 28.75,
          "lane": "left",
          "x": 0.19,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.26
        },
        {
          "time": 29.016,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 29.302,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 29.53,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 29.757,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 30.719,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.26
        },
        {
          "time": 30.979,
          "lane": "left",
          "x": 0.27,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.224,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.469,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.714,
          "lane": "right",
          "x": 0.51,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.958,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.203,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.448,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.698,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.13
        },
        {
          "time": 32.865,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.115
        },
        {
          "time": 33.448,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.089
        },
        {
          "time": 33.672,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.224
        },
        {
          "time": 33.953,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.167
        },
        {
          "time": 34.453,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 34.745,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 35.042,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 62,
          "vocalDuration": 0.276
        },
        {
          "time": 35.484,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.279
        },
        {
          "time": 35.763,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.279
        },
        {
          "time": 36.453,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 36.698,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 36.953,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.266
        },
        {
          "time": 37.219,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 37.457,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 37.694,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 38.427,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.177
        },
        {
          "time": 38.661,
          "lane": "left",
          "x": 0.1,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.26
        },
        {
          "time": 38.922,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.145,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.368,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.592,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.815,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.038,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.261,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.484,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.193
        },
        {
          "time": 40.698,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.13
        },
        {
          "time": 40.922,
          "lane": "left",
          "x": 0.49,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.297
        },
        {
          "time": 41.224,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 41.708,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 41.951,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 42.194,
          "lane": "left",
          "x": 0.66,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 42.464,
          "lane": "right",
          "x": 0.21,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.177
        },
        {
          "time": 42.646,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.299
        },
        {
          "time": 42.945,
          "lane": "right",
          "x": 0.15,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.299
        },
        {
          "time": 43.307,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.245
        },
        {
          "time": 43.557,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 43.797,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.036,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.276,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.521,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 44.766,
          "lane": "left",
          "x": 0.27,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.01,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.255,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.505,
          "lane": "right",
          "x": 0.51,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 45.729,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 45.99,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.339
        },
        {
          "time": 46.49,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 46.646,
          "lane": "right",
          "x": 0.69,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 46.858,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 47.069,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 47.281,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 47.521,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 47.76,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48.24,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48.479,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 48.729,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 48.979,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 49.229,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 49.484,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.141
        },
        {
          "time": 49.625,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.151
        },
        {
          "time": 49.99,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 50.203,
          "lane": "right",
          "x": 0.13,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 50.479,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.146
        },
        {
          "time": 50.63,
          "lane": "right",
          "x": 0.23,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 50.911,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 51.229,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.068
        },
        {
          "time": 51.297,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.141
        },
        {
          "time": 51.698,
          "lane": "left",
          "x": 0.22,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 51.953,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 52.208,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 52.469,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 52.72,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 52.971,
          "lane": "right",
          "x": 0.5,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 53.223,
          "lane": "left",
          "x": 0.27,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 53.474,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 53.701,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 53.953,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 54.12,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.068
        },
        {
          "time": 54.474,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 72,
          "vocalDuration": 0.266
        },
        {
          "time": 54.745,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 54.977,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.208,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.44,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.677,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.281
        },
        {
          "time": 55.964,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.219
        },
        {
          "time": 56.182,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.219
        },
        {
          "time": 56.432,
          "lane": "right",
          "x": 0.32,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.281
        },
        {
          "time": 56.969,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 57.198,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 57.462,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 57.726,
          "lane": "right",
          "x": 0.11,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 58,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.211
        },
        {
          "time": 58.211,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.211
        },
        {
          "time": 58.453,
          "lane": "left",
          "x": 0.25,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.115
        },
        {
          "time": 58.714,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.135
        },
        {
          "time": 58.859,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.078,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.297,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.516,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.734,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.958,
          "lane": "right",
          "x": 0.49,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.115
        },
        {
          "time": 60.411,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.068
        },
        {
          "time": 60.479,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 60.943,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.193,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.443,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.693,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.943,
          "lane": "right",
          "x": 0.49,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.141
        },
        {
          "time": 62.089,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.115
        },
        {
          "time": 62.427,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.068
        },
        {
          "time": 62.5,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 62.984,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.227,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.469,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.711,
          "lane": "right",
          "x": 0.24,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.958,
          "lane": "left",
          "x": 0.5,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.094
        },
        {
          "time": 64.484,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.151
        },
        {
          "time": 65.135,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 65.229,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.151
        },
        {
          "time": 65.729,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 65.979,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.141
        },
        {
          "time": 66.13,
          "lane": "left",
          "x": 0.26,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.13
        },
        {
          "time": 66.458,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 66.708,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 66.958,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.208,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.458,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.708,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.964,
          "lane": "right",
          "x": 0.5,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 68.49,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 68.72,
          "lane": "right",
          "x": 0.56,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 68.951,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 69.181,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 69.411,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.125
        },
        {
          "time": 69.542,
          "lane": "right",
          "x": 0.56,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.141
        },
        {
          "time": 69.958,
          "lane": "right",
          "x": 0.5,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.078
        },
        {
          "time": 70.406,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 70.536,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 70.797,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.024,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.251,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.478,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.705,
          "lane": "left",
          "x": 0.56,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.938,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.073
        },
        {
          "time": 72.182,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.232
        },
        {
          "time": 72.414,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.232
        },
        {
          "time": 73.193,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 73.448,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.125
        },
        {
          "time": 73.573,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.125
        },
        {
          "time": 73.979,
          "lane": "right",
          "x": 0.26,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.24
        },
        {
          "time": 74.224,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.448,
          "lane": "right",
          "x": 0.34,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.672,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.896,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 75.49,
          "lane": "left",
          "x": 0.11,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 75.742,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.214
        },
        {
          "time": 76.266,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.135
        },
        {
          "time": 76.474,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76.727,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76.984,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.208
        },
        {
          "time": 77.505,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.234
        },
        {
          "time": 77.745,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.141
        },
        {
          "time": 78.484,
          "lane": "right",
          "x": 0.51,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.323
        },
        {
          "time": 78.813,
          "lane": "left",
          "x": 0.5,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.12
        },
        {
          "time": 78.948,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.2,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.452,
          "lane": "right",
          "x": 0.34,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.704,
          "lane": "left",
          "x": 0.66,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.956,
          "lane": "right",
          "x": 0.27,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 80.208,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.281
        },
        {
          "time": 80.49,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.349
        },
        {
          "time": 80.844,
          "lane": "left",
          "x": 0.47,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.266
        },
        {
          "time": 81.182,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.193
        },
        {
          "time": 81.38,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.089
        },
        {
          "time": 81.958,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.263
        },
        {
          "time": 82.221,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.263
        },
        {
          "time": 82.49,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.211
        },
        {
          "time": 82.701,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.211
        },
        {
          "time": 82.932,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 83.271,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.536,
          "lane": "left",
          "x": 0.19,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.958,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.229
        },
        {
          "time": 84.188,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.188
        },
        {
          "time": 84.385,
          "lane": "right",
          "x": 0.56,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.083
        },
        {
          "time": 84.724,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 84.979,
          "lane": "left",
          "x": 0.17,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.214
        },
        {
          "time": 85.198,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.258
        },
        {
          "time": 85.456,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.258
        },
        {
          "time": 85.719,
          "lane": "right",
          "x": 0.51,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.089
        },
        {
          "time": 85.896,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.161
        },
        {
          "time": 86.943,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.189,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.436,
          "lane": "right",
          "x": 0.34,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.682,
          "lane": "left",
          "x": 0.5,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.929,
          "lane": "right",
          "x": 0.27,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 88.175,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 88.422,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.089
        },
        {
          "time": 88.516,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.161
        },
        {
          "time": 88.901,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.234
        },
        {
          "time": 89.224,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.229
        },
        {
          "time": 89.453,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.229
        },
        {
          "time": 89.688,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 89.936,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 90.184,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 90.443,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.203
        },
        {
          "time": 90.646,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 90.859,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.073,
          "lane": "right",
          "x": 0.46,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.286,
          "lane": "left",
          "x": 0.23,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.505,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 91.747,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 91.99,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 92.232,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 92.479,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 92.723,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 92.966,
          "lane": "right",
          "x": 0.6,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 93.21,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 93.458,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 93.716,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 93.979,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.333
        },
        {
          "time": 94.458,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.172
        },
        {
          "time": 94.635,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 94.927,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 95.224,
          "lane": "right",
          "x": 0.29,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.266
        },
        {
          "time": 95.49,
          "lane": "left",
          "x": 0.7,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.219
        },
        {
          "time": 95.708,
          "lane": "right",
          "x": 0.21,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 95.969,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.229,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.49,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.75,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 96.983,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 97.215,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 97.458,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.135
        },
        {
          "time": 97.635,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.172
        },
        {
          "time": 97.813,
          "lane": "left",
          "x": 0.28,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 98.422,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.172
        },
        {
          "time": 98.599,
          "lane": "left",
          "x": 0.23,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.224
        },
        {
          "time": 98.823,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.224
        },
        {
          "time": 99.047,
          "lane": "left",
          "x": 0.17,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 99.203,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 99.5,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 99.746,
          "lane": "right",
          "x": 0.71,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 99.992,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 100.238,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 100.484,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 100.646,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 100.913,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 101.181,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 101.448,
          "lane": "left",
          "x": 0.53,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.253
        },
        {
          "time": 101.701,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.253
        },
        {
          "time": 101.964,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 102.458,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 102.714,
          "lane": "left",
          "x": 0.69,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 102.956,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.198,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.44,
          "lane": "right",
          "x": 0.14,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.688,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.276
        },
        {
          "time": 103.969,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.375
        },
        {
          "time": 104.406,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 81,
          "vocalDuration": 0.234
        },
        {
          "time": 104.885,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.313
        },
        {
          "time": 105.198,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 105.448,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 105.698,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 106,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.365
        },
        {
          "time": 106.464,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 106.708,
          "lane": "right",
          "x": 0.48,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 106.943,
          "lane": "left",
          "x": 0.08,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 107.208,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 107.411,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 107.615,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 108.089,
          "lane": "left",
          "x": 0.25,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 108.286,
          "lane": "right",
          "x": 0.56,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.161
        },
        {
          "time": 108.49,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 108.74,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 108.99,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.24,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.49,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.74,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 110.516,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 110.73,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 110.945,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 111.16,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 111.375,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.318
        },
        {
          "time": 111.693,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.25
        },
        {
          "time": 111.964,
          "lane": "left",
          "x": 0.5,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.073
        },
        {
          "time": 112.38,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.094
        },
        {
          "time": 112.479,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.135
        },
        {
          "time": 112.885,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 90,
          "vocalDuration": 0.302
        },
        {
          "time": 113.208,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.167
        },
        {
          "time": 113.5,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.078
        },
        {
          "time": 113.714,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 113.979,
          "lane": "left",
          "x": 0.17,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 114.458,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 114.688,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 114.917,
          "lane": "right",
          "x": 0.48,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.146,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.375,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.604,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 116.089,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.13
        },
        {
          "time": 117.552,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.206
        },
        {
          "time": 117.758,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.206
        },
        {
          "time": 117.964,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 67,
          "vocalDuration": 0.083
        },
        {
          "time": 118.552,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 118.781,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.01,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.24,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.469,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.698,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.932,
          "lane": "right",
          "x": 0.26,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.141
        },
        {
          "time": 120.49,
          "lane": "left",
          "x": 0.56,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.167
        },
        {
          "time": 121.161,
          "lane": "right",
          "x": 0.15,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.229
        },
        {
          "time": 121.464,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.167
        },
        {
          "time": 121.693,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 121.922,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.271
        },
        {
          "time": 123.74,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.146
        },
        {
          "time": 123.885,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.26
        },
        {
          "time": 124.151,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.141
        },
        {
          "time": 124.292,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.234
        },
        {
          "time": 124.531,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.172
        },
        {
          "time": 125.672,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 125.888,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 126.177,
          "lane": "left",
          "x": 0.11,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.146
        },
        {
          "time": 126.323,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.307
        },
        {
          "time": 126.641,
          "lane": "left",
          "x": 0.21,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.26
        },
        {
          "time": 127.651,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.151
        },
        {
          "time": 127.802,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.13
        },
        {
          "time": 128.164,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 128.401,
          "lane": "right",
          "x": 0.72,
          "type": "sushi",
          "pitch": 77,
          "vocalDuration": 0.156
        },
        {
          "time": 128.688,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.13
        },
        {
          "time": 129.948,
          "lane": "right",
          "x": 0.71,
          "type": "fish",
          "pitch": 89,
          "vocalDuration": 0.24
        },
        {
          "time": 130.49,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.115
        },
        {
          "time": 130.62,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.12
        },
        {
          "time": 131.021,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.188
        },
        {
          "time": 131.214,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.429,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.644,
          "lane": "left",
          "x": 0.71,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.943,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.182
        },
        {
          "time": 132.182,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 132.49,
          "lane": "right",
          "x": 0.25,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.177
        },
        {
          "time": 132.667,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 133.01,
          "lane": "right",
          "x": 0.16,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.089
        },
        {
          "time": 133.208,
          "lane": "left",
          "x": 0.47,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.457,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.705,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.958,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.174,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.389,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.609,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 134.842,
          "lane": "right",
          "x": 0.47,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.074,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.307,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.539,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.771,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.004,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.236,
          "lane": "right",
          "x": 0.71,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.474,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 136.704,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 136.934,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.164,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.394,
          "lane": "left",
          "x": 0.53,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.624,
          "lane": "right",
          "x": 0.45,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.853,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 138.474,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 138.724,
          "lane": "left",
          "x": 0.71,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 139,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.276
        },
        {
          "time": 139.286,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.193
        },
        {
          "time": 139.505,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 139.737,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 139.974,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 140.281,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.219
        },
        {
          "time": 141.146,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 141.432,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 141.719,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.266
        },
        {
          "time": 141.984,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.266
        },
        {
          "time": 142.255,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.333
        },
        {
          "time": 142.594,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 142.822,
          "lane": "right",
          "x": 0.47,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.051,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.279,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.508,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.736,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.965,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 144.193,
          "lane": "right",
          "x": 0.71,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 144.427,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 144.682,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 144.938,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.193,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.448,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.703,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 146.469,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 146.693,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.302
        },
        {
          "time": 146.995,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 147.224,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 147.464,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 147.948,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 148.193,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 148.469,
          "lane": "right",
          "x": 0.14,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.203
        },
        {
          "time": 148.677,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 148.908,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.138,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.368,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.599,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.829,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.06,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.29,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.615,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 150.843,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.072,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.3,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.529,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.757,
          "lane": "right",
          "x": 0.69,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.986,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 152.214,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 152.448,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.146
        },
        {
          "time": 152.599,
          "lane": "right",
          "x": 0.51,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 152.845,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.092,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.339,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.585,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.832,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 154.323,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.073
        },
        {
          "time": 154.484,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.242
        },
        {
          "time": 154.727,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 72,
          "vocalDuration": 0.242
        },
        {
          "time": 154.969,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 155.219,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.276
        },
        {
          "time": 155.495,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 155.74,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 155.984,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.208
        },
        {
          "time": 157.151,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.377,
          "lane": "left",
          "x": 0.28,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.603,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.829,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 158.055,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 158.281,
          "lane": "left",
          "x": 0.15,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.5,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.172
        },
        {
          "time": 158.672,
          "lane": "left",
          "x": 0.21,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 158.943,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 159.219,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.182
        },
        {
          "time": 159.406,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 159.643,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 159.879,
          "lane": "right",
          "x": 0.6,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.116,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.352,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.589,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.826,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.062,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.299,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.535,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.772,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 162.008,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 162.292,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.156
        },
        {
          "time": 162.51,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.146
        },
        {
          "time": 162.661,
          "lane": "right",
          "x": 0.15,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 162.866,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 163.071,
          "lane": "right",
          "x": 0.23,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 163.276,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.208
        },
        {
          "time": 163.484,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 163.738,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 163.992,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 164.246,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 164.552,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 164.794,
          "lane": "left",
          "x": 0.13,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.036,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.279,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.521,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 165.747,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 166,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.208
        },
        {
          "time": 166.281,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.188
        },
        {
          "time": 166.49,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.224
        },
        {
          "time": 166.719,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 166.977,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 167.24,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.276
        },
        {
          "time": 167.516,
          "lane": "right",
          "x": 0.46,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.219
        },
        {
          "time": 167.734,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 167.998,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 168.262,
          "lane": "left",
          "x": 0.68,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 168.526,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 168.762,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 168.997,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 169.233,
          "lane": "left",
          "x": 0.53,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 169.5,
          "lane": "right",
          "x": 0.13,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.12
        },
        {
          "time": 169.656,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.193
        },
        {
          "time": 169.854,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 170.464,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.135
        },
        {
          "time": 170.604,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 170.814,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 171.024,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 171.24,
          "lane": "left",
          "x": 0.22,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 171.531,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 171.777,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.023,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.27,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.531,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 172.779,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.026,
          "lane": "right",
          "x": 0.68,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.273,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.521,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 173.776,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 174.036,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.219
        },
        {
          "time": 174.5,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 174.76,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 175.005,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 175.25,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 175.484,
          "lane": "left",
          "x": 0.71,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 175.719,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 176,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.198
        },
        {
          "time": 176.198,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.198
        },
        {
          "time": 176.443,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 81,
          "vocalDuration": 0.237
        },
        {
          "time": 176.68,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 81,
          "vocalDuration": 0.237
        },
        {
          "time": 176.917,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.05
        },
        {
          "time": 177.446,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 177.71,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 178.036,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.333
        },
        {
          "time": 178.474,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 178.745,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 178.839,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.067,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.295,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.523,
          "lane": "right",
          "x": 0.48,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.751,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 180.5,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 180.797,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.04,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.282,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.525,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.768,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 182.521,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 182.776,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 183.036,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.272,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.508,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.743,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 184.182,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 184.344,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.13
        },
        {
          "time": 184.792,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.135
        },
        {
          "time": 185.021,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.203
        },
        {
          "time": 185.229,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 185.495,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.125
        },
        {
          "time": 185.74,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 185.974,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.172
        },
        {
          "time": 186.474,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 186.715,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 186.957,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.198,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.439,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.681,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 188.016,
          "lane": "right",
          "x": 0.49,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.094
        },
        {
          "time": 188.115,
          "lane": "left",
          "x": 0.15,
          "type": "donut",
          "pitch": 62,
          "vocalDuration": 0.104
        },
        {
          "time": 188.51,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 188.75,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 188.99,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.229,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.469,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.708,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 190.547,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 190.805,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.063,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.32,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.578,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.836,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 192.464,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.115
        },
        {
          "time": 192.583,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.255
        },
        {
          "time": 192.953,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 193.177,
          "lane": "left",
          "x": 0.5,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.436,
          "lane": "right",
          "x": 0.11,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.694,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.958,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.193
        },
        {
          "time": 194.151,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.193
        },
        {
          "time": 194.479,
          "lane": "right",
          "x": 0.25,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.161
        },
        {
          "time": 194.74,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 194.988,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.235,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.483,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.731,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 196.219,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.078
        },
        {
          "time": 196.302,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.182
        },
        {
          "time": 196.755,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.005,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.255,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.505,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.755,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 198.01,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.094
        },
        {
          "time": 198.516,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 198.734,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 198.953,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 199.172,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 199.391,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 199.592,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 199.793,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 200.479,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 200.62,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 62,
          "vocalDuration": 0.104
        },
        {
          "time": 201.047,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 201.229,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.125
        },
        {
          "time": 201.526,
          "lane": "right",
          "x": 0.1,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.177
        },
        {
          "time": 201.745,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 201.979,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.156
        },
        {
          "time": 202.625,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 202.845,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.064,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.284,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.503,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.723,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 204.109,
          "lane": "left",
          "x": 0.15,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.063
        },
        {
          "time": 204.313,
          "lane": "right",
          "x": 0.48,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 204.51,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 204.756,
          "lane": "right",
          "x": 0.56,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.002,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.247,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.493,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.739,
          "lane": "right",
          "x": 0.56,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 206.359,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 206.542,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.271
        },
        {
          "time": 206.818,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.047,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.276,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.505,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.734,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 208.297,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 208.495,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.234
        },
        {
          "time": 209.182,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.188
        },
        {
          "time": 209.443,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 209.703,
          "lane": "right",
          "x": 0.08,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.193
        },
        {
          "time": 209.927,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.193
        },
        {
          "time": 210.125,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.109
        },
        {
          "time": 210.349,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.276
        }
      ]
    },
    "normal": {
      "noteTravelTime": 1.9,
      "notes": [
        {
          "time": 2.464,
          "lane": "left",
          "x": 0.1,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.083
        },
        {
          "time": 2.656,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.135
        },
        {
          "time": 2.844,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.063,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.281,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.505,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.375
        },
        {
          "time": 3.917,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.292
        },
        {
          "time": 4.208,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.365
        },
        {
          "time": 4.578,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 72,
          "vocalDuration": 0.333
        },
        {
          "time": 4.943,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.149,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.356,
          "lane": "right",
          "x": 0.12,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.563,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.203
        },
        {
          "time": 6.255,
          "lane": "right",
          "x": 0.34,
          "type": "fish",
          "pitch": 85,
          "vocalDuration": 0.156
        },
        {
          "time": 6.552,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 6.823,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.354
        },
        {
          "time": 7.182,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.245
        },
        {
          "time": 7.443,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.068
        },
        {
          "time": 8.365,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.078
        },
        {
          "time": 8.51,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.099
        },
        {
          "time": 9.911,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.078
        },
        {
          "time": 10.958,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.207,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.456,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.704,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.958,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.12
        },
        {
          "time": 12.083,
          "lane": "left",
          "x": 0.56,
          "type": "donut",
          "pitch": 62,
          "vocalDuration": 0.089
        },
        {
          "time": 12.458,
          "lane": "right",
          "x": 0.21,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.13
        },
        {
          "time": 12.599,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.271
        },
        {
          "time": 12.901,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 12.979,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.217,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.456,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.694,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.948,
          "lane": "left",
          "x": 0.22,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.104
        },
        {
          "time": 14.479,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 14.693,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 14.906,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 15.12,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 15.339,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.297
        },
        {
          "time": 15.635,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.297
        },
        {
          "time": 16.432,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.13
        },
        {
          "time": 16.568,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.109
        },
        {
          "time": 17.229,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.292
        },
        {
          "time": 17.703,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 17.974,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 18.307,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.13
        },
        {
          "time": 18.438,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 18.671,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 18.904,
          "lane": "right",
          "x": 0.21,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 19.137,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 19.38,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.146
        },
        {
          "time": 19.526,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.208
        },
        {
          "time": 19.734,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.208
        },
        {
          "time": 19.948,
          "lane": "left",
          "x": 0.1,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.115
        },
        {
          "time": 20.469,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 20.714,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 20.958,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.203,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.448,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.693,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.938,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.125
        },
        {
          "time": 22.422,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.063
        },
        {
          "time": 22.49,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.286
        },
        {
          "time": 22.781,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.01,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.24,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.469,
          "lane": "right",
          "x": 0.21,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.698,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.932,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.083
        },
        {
          "time": 24.198,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.255
        },
        {
          "time": 24.458,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 25.203,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 25.458,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.104
        },
        {
          "time": 25.693,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.224
        },
        {
          "time": 25.958,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 26.448,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 26.703,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 26.958,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 27.521,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 27.776,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 28.49,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.26
        },
        {
          "time": 28.75,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.26
        },
        {
          "time": 29.016,
          "lane": "right",
          "x": 0.1,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 29.302,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 29.53,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 29.757,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 30.719,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.26
        },
        {
          "time": 30.979,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.224,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.469,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.714,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.958,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.203,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.448,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.698,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.13
        },
        {
          "time": 32.865,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.115
        },
        {
          "time": 33.448,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.089
        },
        {
          "time": 33.672,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.224
        },
        {
          "time": 33.953,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.167
        },
        {
          "time": 34.453,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 34.745,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 35.042,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 62,
          "vocalDuration": 0.276
        },
        {
          "time": 35.484,
          "lane": "right",
          "x": 0.23,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.279
        },
        {
          "time": 35.763,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.279
        },
        {
          "time": 36.453,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 36.698,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 36.953,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.266
        },
        {
          "time": 37.219,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 37.457,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 37.694,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 38.427,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.177
        },
        {
          "time": 38.661,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.26
        },
        {
          "time": 38.922,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.145,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.368,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.592,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.815,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.038,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.261,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.484,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.193
        },
        {
          "time": 40.698,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.13
        },
        {
          "time": 40.922,
          "lane": "left",
          "x": 0.34,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.297
        },
        {
          "time": 41.224,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 41.708,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 41.951,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 42.194,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 42.464,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.177
        },
        {
          "time": 42.646,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.299
        },
        {
          "time": 42.945,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.299
        },
        {
          "time": 43.307,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.245
        },
        {
          "time": 43.557,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 43.797,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.036,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.276,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.521,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 44.766,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.01,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.255,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.505,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 45.729,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 45.99,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.339
        },
        {
          "time": 46.49,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 46.646,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 46.858,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 47.069,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 47.281,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 47.521,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 47.76,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48.24,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48.479,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 48.729,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 48.979,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 49.229,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 49.484,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.141
        },
        {
          "time": 49.625,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.151
        },
        {
          "time": 49.776,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 49.99,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 50.203,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 50.479,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.146
        },
        {
          "time": 50.63,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 50.911,
          "lane": "left",
          "x": 0.15,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 51.229,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.068
        },
        {
          "time": 51.297,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.141
        },
        {
          "time": 51.443,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 51.698,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 51.953,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 52.208,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 52.469,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 52.72,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 52.971,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 53.223,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 53.474,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 53.701,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 53.953,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 54.12,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.068
        },
        {
          "time": 54.474,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 72,
          "vocalDuration": 0.266
        },
        {
          "time": 54.745,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 54.977,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.208,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.44,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.677,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.281
        },
        {
          "time": 55.964,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.219
        },
        {
          "time": 56.182,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.219
        },
        {
          "time": 56.432,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.281
        },
        {
          "time": 56.969,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 57.198,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 57.462,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 57.726,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 58,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.211
        },
        {
          "time": 58.211,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.211
        },
        {
          "time": 58.453,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.115
        },
        {
          "time": 58.714,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.135
        },
        {
          "time": 58.859,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.078,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.297,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.516,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.734,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.958,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.115
        },
        {
          "time": 60.411,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.068
        },
        {
          "time": 60.479,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 60.708,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 60.943,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.193,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.443,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.693,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.943,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.141
        },
        {
          "time": 62.089,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.115
        },
        {
          "time": 62.427,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.068
        },
        {
          "time": 62.5,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 62.742,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 62.984,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.227,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.469,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.711,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.958,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.094
        },
        {
          "time": 64.484,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.151
        },
        {
          "time": 65.135,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 65.229,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.151
        },
        {
          "time": 65.729,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 65.979,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.141
        },
        {
          "time": 66.13,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.13
        },
        {
          "time": 66.458,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 66.708,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 66.958,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.208,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.458,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.708,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.964,
          "lane": "right",
          "x": 0.23,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 68.49,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 68.72,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 68.951,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 69.181,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 69.411,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.125
        },
        {
          "time": 69.542,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.141
        },
        {
          "time": 69.682,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.276
        },
        {
          "time": 69.958,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.078
        },
        {
          "time": 70.406,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 70.536,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 70.797,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.024,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.251,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.478,
          "lane": "right",
          "x": 0.21,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.705,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.938,
          "lane": "right",
          "x": 0.1,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.073
        },
        {
          "time": 72.182,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.232
        },
        {
          "time": 72.414,
          "lane": "right",
          "x": 0.21,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.232
        },
        {
          "time": 73.193,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 73.448,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.125
        },
        {
          "time": 73.573,
          "lane": "left",
          "x": 0.22,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.125
        },
        {
          "time": 73.979,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.24
        },
        {
          "time": 74.224,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.448,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.672,
          "lane": "left",
          "x": 0.23,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.896,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 75.49,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 75.742,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.214
        },
        {
          "time": 76.266,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.135
        },
        {
          "time": 76.474,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76.727,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76.984,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.208
        },
        {
          "time": 77.505,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.234
        },
        {
          "time": 77.745,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.141
        },
        {
          "time": 78.484,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.323
        },
        {
          "time": 78.813,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.12
        },
        {
          "time": 78.948,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.2,
          "lane": "left",
          "x": 0.23,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.452,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.704,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.956,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 80.208,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.281
        },
        {
          "time": 80.49,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.349
        },
        {
          "time": 80.844,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.266
        },
        {
          "time": 81.182,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.193
        },
        {
          "time": 81.38,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.089
        },
        {
          "time": 81.474,
          "lane": "right",
          "x": 0.34,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 81.682,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 81.958,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.263
        },
        {
          "time": 82.221,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.263
        },
        {
          "time": 82.49,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.211
        },
        {
          "time": 82.701,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.211
        },
        {
          "time": 82.932,
          "lane": "right",
          "x": 0.21,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 83.005,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.271,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.536,
          "lane": "left",
          "x": 0.23,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.958,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.229
        },
        {
          "time": 84.188,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.188
        },
        {
          "time": 84.385,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.083
        },
        {
          "time": 84.474,
          "lane": "left",
          "x": 0.23,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 84.724,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 84.979,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.214
        },
        {
          "time": 85.198,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.258
        },
        {
          "time": 85.456,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.258
        },
        {
          "time": 85.719,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.089
        },
        {
          "time": 85.896,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.161
        },
        {
          "time": 86.943,
          "lane": "right",
          "x": 0.23,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.189,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.436,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.682,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.929,
          "lane": "right",
          "x": 0.23,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 88.175,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 88.422,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.089
        },
        {
          "time": 88.516,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.161
        },
        {
          "time": 88.688,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.13
        },
        {
          "time": 88.901,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.234
        },
        {
          "time": 89.224,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.229
        },
        {
          "time": 89.453,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.229
        },
        {
          "time": 89.688,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 89.936,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 90.184,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 90.443,
          "lane": "left",
          "x": 0.5,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.203
        },
        {
          "time": 90.646,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 90.859,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.073,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.286,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.505,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 91.747,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 91.99,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 92.232,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 92.479,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 92.723,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 92.966,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 93.21,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 93.458,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 93.716,
          "lane": "left",
          "x": 0.26,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 93.979,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.333
        },
        {
          "time": 94.458,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.172
        },
        {
          "time": 94.635,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 94.927,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 95.224,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.266
        },
        {
          "time": 95.49,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.219
        },
        {
          "time": 95.708,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 95.969,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.229,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.49,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.75,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 96.983,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 97.215,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 97.458,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.135
        },
        {
          "time": 97.635,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.172
        },
        {
          "time": 97.813,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 98.422,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.172
        },
        {
          "time": 98.599,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.224
        },
        {
          "time": 98.823,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.224
        },
        {
          "time": 99.047,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 99.203,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 99.5,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 99.746,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 99.992,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 100.238,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 100.484,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 100.646,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 100.913,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 101.181,
          "lane": "right",
          "x": 0.23,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 101.448,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.253
        },
        {
          "time": 101.701,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.253
        },
        {
          "time": 101.964,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 102.458,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 102.714,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 102.956,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.198,
          "lane": "left",
          "x": 0.26,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.44,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.688,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.276
        },
        {
          "time": 103.969,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.375
        },
        {
          "time": 104.406,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 81,
          "vocalDuration": 0.234
        },
        {
          "time": 104.885,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.313
        },
        {
          "time": 105.198,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 105.448,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 105.698,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 106,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.365
        },
        {
          "time": 106.464,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 106.708,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 106.943,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 107.208,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 107.411,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 107.615,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 108.089,
          "lane": "left",
          "x": 0.09,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 108.286,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.161
        },
        {
          "time": 108.49,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 108.74,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 108.99,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.24,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.49,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.74,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 110.516,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 110.73,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 110.945,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 111.16,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 111.375,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.318
        },
        {
          "time": 111.693,
          "lane": "right",
          "x": 0.21,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.25
        },
        {
          "time": 111.964,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.073
        },
        {
          "time": 112.38,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.094
        },
        {
          "time": 112.479,
          "lane": "left",
          "x": 0.22,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.135
        },
        {
          "time": 112.615,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.083
        },
        {
          "time": 112.885,
          "lane": "left",
          "x": 0.25,
          "type": "iceCream",
          "pitch": 90,
          "vocalDuration": 0.302
        },
        {
          "time": 113.208,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.167
        },
        {
          "time": 113.5,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.078
        },
        {
          "time": 113.714,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 113.979,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 114.458,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 114.688,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 114.917,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.146,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.375,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.604,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 116.089,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.13
        },
        {
          "time": 117.552,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.206
        },
        {
          "time": 117.758,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.206
        },
        {
          "time": 117.964,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 67,
          "vocalDuration": 0.083
        },
        {
          "time": 118.552,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 118.781,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.01,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.24,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.469,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.698,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.932,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.141
        },
        {
          "time": 120.49,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.167
        },
        {
          "time": 121.161,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.229
        },
        {
          "time": 121.464,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.167
        },
        {
          "time": 121.693,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 121.922,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.271
        },
        {
          "time": 123.74,
          "lane": "right",
          "x": 0.21,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.146
        },
        {
          "time": 123.885,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.26
        },
        {
          "time": 124.151,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.141
        },
        {
          "time": 124.292,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.234
        },
        {
          "time": 124.531,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.172
        },
        {
          "time": 125.672,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 125.888,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 126.177,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.146
        },
        {
          "time": 126.323,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.307
        },
        {
          "time": 126.641,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.26
        },
        {
          "time": 127.651,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.151
        },
        {
          "time": 127.802,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.13
        },
        {
          "time": 127.932,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 128.164,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 128.401,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 77,
          "vocalDuration": 0.156
        },
        {
          "time": 128.688,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.13
        },
        {
          "time": 129.948,
          "lane": "right",
          "x": 0.49,
          "type": "fish",
          "pitch": 89,
          "vocalDuration": 0.24
        },
        {
          "time": 130.49,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.115
        },
        {
          "time": 130.62,
          "lane": "right",
          "x": 0.29,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.12
        },
        {
          "time": 130.745,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.219
        },
        {
          "time": 131.021,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.188
        },
        {
          "time": 131.214,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.429,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.644,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.943,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.182
        },
        {
          "time": 132.182,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 132.49,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.177
        },
        {
          "time": 132.667,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 133.01,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.089
        },
        {
          "time": 133.208,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.457,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.705,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.958,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.174,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.389,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.609,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 134.842,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.074,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.307,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.539,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.771,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.004,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.236,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.474,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 136.704,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 136.934,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.164,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.394,
          "lane": "left",
          "x": 0.26,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.624,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.853,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 138.474,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 138.724,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 139,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.276
        },
        {
          "time": 139.286,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.193
        },
        {
          "time": 139.505,
          "lane": "right",
          "x": 0.29,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 139.737,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 139.974,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 140.281,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.219
        },
        {
          "time": 141.146,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 141.432,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 141.719,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.266
        },
        {
          "time": 141.984,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.266
        },
        {
          "time": 142.255,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.333
        },
        {
          "time": 142.594,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 142.822,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.051,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.279,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.508,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.736,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.965,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 144.193,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 144.427,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 144.682,
          "lane": "right",
          "x": 0.26,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 144.938,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.193,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.448,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.703,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 146.469,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 146.693,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.302
        },
        {
          "time": 146.995,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 147.224,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 147.464,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 147.948,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 148.193,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 148.469,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.203
        },
        {
          "time": 148.677,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 148.908,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.138,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.368,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.599,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.829,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.06,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.29,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.615,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 150.843,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.072,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.3,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.529,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.757,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.986,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 152.214,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 152.448,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.146
        },
        {
          "time": 152.599,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 152.845,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.092,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.339,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.585,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.832,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 154.323,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.073
        },
        {
          "time": 154.484,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.242
        },
        {
          "time": 154.727,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 72,
          "vocalDuration": 0.242
        },
        {
          "time": 154.969,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 155.219,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.276
        },
        {
          "time": 155.495,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 155.74,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 155.984,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.208
        },
        {
          "time": 157.151,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.377,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.603,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.829,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 158.055,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 158.281,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.5,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.172
        },
        {
          "time": 158.672,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 158.943,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 159.219,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.182
        },
        {
          "time": 159.406,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 159.643,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 159.879,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.116,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.352,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.589,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.826,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.062,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.299,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.535,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.772,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 162.008,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 162.292,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.156
        },
        {
          "time": 162.51,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.146
        },
        {
          "time": 162.661,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 162.866,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 163.071,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 163.276,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.208
        },
        {
          "time": 163.484,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 163.738,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 163.992,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 164.246,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 164.552,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 164.794,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.036,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.279,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.521,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 165.747,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 166,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.208
        },
        {
          "time": 166.281,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.188
        },
        {
          "time": 166.49,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.224
        },
        {
          "time": 166.719,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 166.977,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 167.24,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.276
        },
        {
          "time": 167.516,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.219
        },
        {
          "time": 167.734,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 167.998,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 168.262,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 168.526,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 168.762,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 168.997,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 169.233,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 169.5,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.12
        },
        {
          "time": 169.656,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.193
        },
        {
          "time": 169.854,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 170.464,
          "lane": "left",
          "x": 0.15,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.135
        },
        {
          "time": 170.604,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 170.814,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 171.024,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 171.24,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 171.531,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 171.777,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.023,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.27,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.531,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 172.779,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.026,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.273,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.521,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 173.776,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 174.036,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.219
        },
        {
          "time": 174.5,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 174.76,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 175.005,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 175.25,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 175.484,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 175.719,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 176,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.198
        },
        {
          "time": 176.198,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.198
        },
        {
          "time": 176.443,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 81,
          "vocalDuration": 0.237
        },
        {
          "time": 176.68,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 81,
          "vocalDuration": 0.237
        },
        {
          "time": 176.917,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.05
        },
        {
          "time": 176.917,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.266
        },
        {
          "time": 177.182,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 177.446,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 177.71,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 178.036,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.333
        },
        {
          "time": 178.474,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 178.745,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 178.839,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.067,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.295,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.523,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.751,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 180.5,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 180.797,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.04,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.282,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.525,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.768,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 182.521,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 182.776,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 183.036,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.272,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.508,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.743,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 184.182,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 184.344,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.13
        },
        {
          "time": 184.479,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 184.615,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 184.792,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.135
        },
        {
          "time": 185.021,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.203
        },
        {
          "time": 185.229,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 185.495,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.125
        },
        {
          "time": 185.74,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 185.974,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.172
        },
        {
          "time": 186.474,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 186.715,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 186.957,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.198,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.439,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.681,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 188.016,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.094
        },
        {
          "time": 188.115,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 62,
          "vocalDuration": 0.104
        },
        {
          "time": 188.51,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 188.75,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 188.99,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.229,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.469,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.708,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 190.547,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 190.805,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.063,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.32,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.578,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.836,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 192.464,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.115
        },
        {
          "time": 192.583,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.255
        },
        {
          "time": 192.953,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 193.177,
          "lane": "left",
          "x": 0.47,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.436,
          "lane": "right",
          "x": 0.23,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.694,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.958,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.193
        },
        {
          "time": 194.151,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.193
        },
        {
          "time": 194.479,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.161
        },
        {
          "time": 194.74,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 194.988,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.235,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.483,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.731,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 196.219,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.078
        },
        {
          "time": 196.302,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.182
        },
        {
          "time": 196.505,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 196.755,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.005,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.255,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.505,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.755,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 198.01,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.094
        },
        {
          "time": 198.516,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 198.734,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 198.953,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 199.172,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 199.391,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 199.592,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 199.793,
          "lane": "left",
          "x": 0.2,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 200.479,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 200.62,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 62,
          "vocalDuration": 0.104
        },
        {
          "time": 200.786,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.089
        },
        {
          "time": 200.938,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 201.047,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 201.229,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.125
        },
        {
          "time": 201.526,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.177
        },
        {
          "time": 201.745,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 201.979,
          "lane": "right",
          "x": 0.1,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.156
        },
        {
          "time": 202.625,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 202.845,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.064,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.284,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.503,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.723,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 204.109,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.063
        },
        {
          "time": 204.313,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 204.51,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 204.756,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.002,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.247,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.493,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.739,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 206.359,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 206.542,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.271
        },
        {
          "time": 206.818,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.047,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.276,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.505,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.734,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 208.297,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 208.495,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.234
        },
        {
          "time": 209.182,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.188
        },
        {
          "time": 209.443,
          "lane": "left",
          "x": 0.1,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 209.703,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.193
        },
        {
          "time": 209.927,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.193
        },
        {
          "time": 210.125,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.109
        },
        {
          "time": 210.349,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.276
        }
      ]
    },
    "hard": {
      "noteTravelTime": 1.9,
      "notes": [
        {
          "time": 2.464,
          "lane": "left",
          "x": 0.1,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.083
        },
        {
          "time": 2.656,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.135
        },
        {
          "time": 2.844,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.063,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.281,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.219
        },
        {
          "time": 3.505,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.375
        },
        {
          "time": 3.917,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.292
        },
        {
          "time": 4.208,
          "lane": "right",
          "x": 0.11,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.365
        },
        {
          "time": 4.578,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 72,
          "vocalDuration": 0.333
        },
        {
          "time": 4.943,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.149,
          "lane": "left",
          "x": 0.12,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.356,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.207
        },
        {
          "time": 5.563,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.203
        },
        {
          "time": 6.255,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 85,
          "vocalDuration": 0.156
        },
        {
          "time": 6.552,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 6.823,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.354
        },
        {
          "time": 7.182,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.245
        },
        {
          "time": 7.443,
          "lane": "right",
          "x": 0.15,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.068
        },
        {
          "time": 8.365,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.078
        },
        {
          "time": 8.51,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.099
        },
        {
          "time": 9.911,
          "lane": "left",
          "x": 0.08,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.078
        },
        {
          "time": 10.958,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.207,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.456,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.704,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.249
        },
        {
          "time": 11.958,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.12
        },
        {
          "time": 12.083,
          "lane": "left",
          "x": 0.51,
          "type": "donut",
          "pitch": 62,
          "vocalDuration": 0.089
        },
        {
          "time": 12.458,
          "lane": "right",
          "x": 0.09,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.13
        },
        {
          "time": 12.599,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.271
        },
        {
          "time": 12.901,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 12.979,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.217,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.456,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.694,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.238
        },
        {
          "time": 13.948,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.104
        },
        {
          "time": 14.479,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 14.693,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 14.906,
          "lane": "right",
          "x": 0.08,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 15.12,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.214
        },
        {
          "time": 15.339,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.297
        },
        {
          "time": 15.635,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.297
        },
        {
          "time": 16.432,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.13
        },
        {
          "time": 16.568,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.109
        },
        {
          "time": 17.229,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.292
        },
        {
          "time": 17.703,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 17.974,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 18.307,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.13
        },
        {
          "time": 18.438,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 18.671,
          "lane": "left",
          "x": 0.31,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 18.904,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 19.137,
          "lane": "left",
          "x": 0.09,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.233
        },
        {
          "time": 19.38,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.146
        },
        {
          "time": 19.526,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.208
        },
        {
          "time": 19.734,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.208
        },
        {
          "time": 19.948,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.115
        },
        {
          "time": 20.469,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 20.714,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 20.958,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.203,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.448,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.693,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.245
        },
        {
          "time": 21.938,
          "lane": "right",
          "x": 0.54,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.125
        },
        {
          "time": 22.422,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.063
        },
        {
          "time": 22.49,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.286
        },
        {
          "time": 22.781,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.01,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.24,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.469,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.698,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.229
        },
        {
          "time": 23.932,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.083
        },
        {
          "time": 24.198,
          "lane": "left",
          "x": 0.09,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.255
        },
        {
          "time": 24.458,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 25.203,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 25.458,
          "lane": "right",
          "x": 0.54,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.104
        },
        {
          "time": 25.693,
          "lane": "left",
          "x": 0.53,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.224
        },
        {
          "time": 25.958,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 26.448,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 26.703,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 26.958,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 27.521,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 27.776,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.255
        },
        {
          "time": 28.49,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.26
        },
        {
          "time": 28.75,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.26
        },
        {
          "time": 29.016,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 29.302,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 29.53,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 29.757,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 30.719,
          "lane": "right",
          "x": 0.11,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.26
        },
        {
          "time": 30.979,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.224,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.469,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.714,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 31.958,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.203,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.448,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 32.698,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.13
        },
        {
          "time": 32.865,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.115
        },
        {
          "time": 33.448,
          "lane": "right",
          "x": 0.1,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.089
        },
        {
          "time": 33.672,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.224
        },
        {
          "time": 33.953,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.167
        },
        {
          "time": 34.453,
          "lane": "left",
          "x": 0.11,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 34.745,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 35.042,
          "lane": "left",
          "x": 0.29,
          "type": "iceCream",
          "pitch": 62,
          "vocalDuration": 0.276
        },
        {
          "time": 35.484,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.279
        },
        {
          "time": 35.763,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.279
        },
        {
          "time": 36.453,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 36.698,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.245
        },
        {
          "time": 36.953,
          "lane": "right",
          "x": 0.1,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.266
        },
        {
          "time": 37.219,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 37.457,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 37.694,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.238
        },
        {
          "time": 38.427,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.177
        },
        {
          "time": 38.661,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.26
        },
        {
          "time": 38.922,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.145,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.368,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.592,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 39.815,
          "lane": "right",
          "x": 0.11,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.038,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.261,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.223
        },
        {
          "time": 40.484,
          "lane": "left",
          "x": 0.12,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.193
        },
        {
          "time": 40.698,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.13
        },
        {
          "time": 40.922,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.297
        },
        {
          "time": 41.224,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.292
        },
        {
          "time": 41.708,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 41.951,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 42.194,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.243
        },
        {
          "time": 42.464,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.177
        },
        {
          "time": 42.646,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.299
        },
        {
          "time": 42.945,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.299
        },
        {
          "time": 43.307,
          "lane": "left",
          "x": 0.15,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.245
        },
        {
          "time": 43.557,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 43.797,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.036,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.276,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.521,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 44.766,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.01,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.255,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 45.505,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 45.729,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 45.99,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.339
        },
        {
          "time": 46.49,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 46.646,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 46.858,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 47.069,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.212
        },
        {
          "time": 47.281,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 47.521,
          "lane": "right",
          "x": 0.13,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 47.76,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48.24,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 48.479,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 48.729,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 48.979,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 49.229,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.25
        },
        {
          "time": 49.484,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.141
        },
        {
          "time": 49.625,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.151
        },
        {
          "time": 49.776,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 49.99,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 50.203,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 50.479,
          "lane": "left",
          "x": 0.13,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.146
        },
        {
          "time": 50.63,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 50.911,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 51.229,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.068
        },
        {
          "time": 51.297,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.141
        },
        {
          "time": 51.443,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 51.698,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 51.953,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 52.208,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 52.469,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 52.72,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 52.971,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 53.223,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.251
        },
        {
          "time": 53.474,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 53.701,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.227
        },
        {
          "time": 53.953,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 54.12,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.068
        },
        {
          "time": 54.474,
          "lane": "right",
          "x": 0.13,
          "type": "cupcake",
          "pitch": 72,
          "vocalDuration": 0.266
        },
        {
          "time": 54.745,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 54.977,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.208,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.44,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.232
        },
        {
          "time": 55.677,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.281
        },
        {
          "time": 55.964,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.219
        },
        {
          "time": 56.182,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.219
        },
        {
          "time": 56.432,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.281
        },
        {
          "time": 56.969,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 57.198,
          "lane": "right",
          "x": 0.11,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 57.462,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 57.726,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.264
        },
        {
          "time": 58,
          "lane": "left",
          "x": 0.11,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.211
        },
        {
          "time": 58.211,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.211
        },
        {
          "time": 58.453,
          "lane": "left",
          "x": 0.31,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.115
        },
        {
          "time": 58.714,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.135
        },
        {
          "time": 58.859,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.078,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.297,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.516,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.734,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 59.958,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.115
        },
        {
          "time": 60.411,
          "lane": "left",
          "x": 0.09,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.068
        },
        {
          "time": 60.479,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 60.708,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 60.943,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.193,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.443,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.693,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 61.943,
          "lane": "right",
          "x": 0.1,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.141
        },
        {
          "time": 62.089,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.115
        },
        {
          "time": 62.427,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.068
        },
        {
          "time": 62.5,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 62.742,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 62.984,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.227,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.469,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.711,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.242
        },
        {
          "time": 63.958,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.094
        },
        {
          "time": 64.484,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.151
        },
        {
          "time": 65.135,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 65.229,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.151
        },
        {
          "time": 65.729,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 65.979,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.141
        },
        {
          "time": 66.13,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.13
        },
        {
          "time": 66.458,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 66.708,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 66.958,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.208,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.458,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.708,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 67.964,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 68.49,
          "lane": "left",
          "x": 0.09,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 68.72,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 68.951,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 69.181,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.23
        },
        {
          "time": 69.411,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.125
        },
        {
          "time": 69.542,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.141
        },
        {
          "time": 69.682,
          "lane": "left",
          "x": 0.53,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.276
        },
        {
          "time": 69.958,
          "lane": "right",
          "x": 0.11,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.078
        },
        {
          "time": 70.406,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 70.536,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 70.797,
          "lane": "left",
          "x": 0.09,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.024,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.251,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.478,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.705,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.227
        },
        {
          "time": 71.938,
          "lane": "right",
          "x": 0.32,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.073
        },
        {
          "time": 72.182,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.232
        },
        {
          "time": 72.414,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.232
        },
        {
          "time": 73.193,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 73.448,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.125
        },
        {
          "time": 73.573,
          "lane": "left",
          "x": 0.1,
          "type": "candy",
          "pitch": 67,
          "vocalDuration": 0.125
        },
        {
          "time": 73.979,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.24
        },
        {
          "time": 74.224,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.448,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.672,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 74.896,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 75.49,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 75.742,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.214
        },
        {
          "time": 76.266,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.135
        },
        {
          "time": 76.474,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76.727,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.253
        },
        {
          "time": 76.984,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.208
        },
        {
          "time": 77.505,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.234
        },
        {
          "time": 77.745,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.141
        },
        {
          "time": 78.484,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.323
        },
        {
          "time": 78.813,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.12
        },
        {
          "time": 78.948,
          "lane": "right",
          "x": 0.11,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.2,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.452,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.704,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 79.956,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 80.208,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.281
        },
        {
          "time": 80.49,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.349
        },
        {
          "time": 80.844,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.266
        },
        {
          "time": 81.182,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.193
        },
        {
          "time": 81.38,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.089
        },
        {
          "time": 81.474,
          "lane": "right",
          "x": 0.1,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 81.682,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 81.958,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.263
        },
        {
          "time": 82.221,
          "lane": "left",
          "x": 0.11,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.263
        },
        {
          "time": 82.49,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.211
        },
        {
          "time": 82.701,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.211
        },
        {
          "time": 82.932,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 83.005,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.271,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.536,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 83.958,
          "lane": "right",
          "x": 0.1,
          "type": "sushi",
          "pitch": 67,
          "vocalDuration": 0.229
        },
        {
          "time": 84.188,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.188
        },
        {
          "time": 84.385,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.083
        },
        {
          "time": 84.474,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 84.724,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.245
        },
        {
          "time": 84.979,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.214
        },
        {
          "time": 85.198,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.258
        },
        {
          "time": 85.456,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.258
        },
        {
          "time": 85.719,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 69,
          "vocalDuration": 0.089
        },
        {
          "time": 85.896,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.161
        },
        {
          "time": 86.943,
          "lane": "right",
          "x": 0.11,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.189,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.436,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.682,
          "lane": "left",
          "x": 0.11,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 87.929,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 88.175,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.247
        },
        {
          "time": 88.422,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.089
        },
        {
          "time": 88.516,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.161
        },
        {
          "time": 88.688,
          "lane": "right",
          "x": 0.29,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.13
        },
        {
          "time": 88.901,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.234
        },
        {
          "time": 89.224,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.229
        },
        {
          "time": 89.453,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.229
        },
        {
          "time": 89.688,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 89.936,
          "lane": "left",
          "x": 0.14,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 90.184,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.248
        },
        {
          "time": 90.443,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.203
        },
        {
          "time": 90.646,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 90.859,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.073,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.286,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.214
        },
        {
          "time": 91.505,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 91.747,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 91.99,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 92.232,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.242
        },
        {
          "time": 92.479,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 92.723,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 92.966,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 93.21,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.243
        },
        {
          "time": 93.458,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 93.716,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 93.979,
          "lane": "right",
          "x": 0.13,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.333
        },
        {
          "time": 94.458,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.172
        },
        {
          "time": 94.635,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 94.927,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 95.224,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.266
        },
        {
          "time": 95.49,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.219
        },
        {
          "time": 95.708,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 95.969,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.229,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.49,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 96.75,
          "lane": "right",
          "x": 0.14,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 96.983,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 97.215,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.233
        },
        {
          "time": 97.458,
          "lane": "left",
          "x": 0.13,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.135
        },
        {
          "time": 97.635,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.172
        },
        {
          "time": 97.813,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 98.422,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.172
        },
        {
          "time": 98.599,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.224
        },
        {
          "time": 98.823,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.224
        },
        {
          "time": 99.047,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 99.203,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 99.5,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 99.746,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 99.992,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 100.238,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 100.484,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 100.646,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 100.913,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 101.181,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.267
        },
        {
          "time": 101.448,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.253
        },
        {
          "time": 101.701,
          "lane": "right",
          "x": 0.14,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.253
        },
        {
          "time": 101.964,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 102.458,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 102.714,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 102.956,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.198,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.44,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 103.688,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 74,
          "vocalDuration": 0.276
        },
        {
          "time": 103.969,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.375
        },
        {
          "time": 104.406,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 81,
          "vocalDuration": 0.234
        },
        {
          "time": 104.885,
          "lane": "right",
          "x": 0.14,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.313
        },
        {
          "time": 105.198,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 105.448,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 105.698,
          "lane": "left",
          "x": 0.13,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.25
        },
        {
          "time": 106,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.365
        },
        {
          "time": 106.464,
          "lane": "left",
          "x": 0.31,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 106.708,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 106.943,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.234
        },
        {
          "time": 107.208,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 107.411,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 107.615,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.203
        },
        {
          "time": 108.089,
          "lane": "left",
          "x": 0.31,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 108.286,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.161
        },
        {
          "time": 108.49,
          "lane": "left",
          "x": 0.08,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 108.74,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 108.99,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.24,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.49,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 109.74,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 110.516,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 110.73,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 110.945,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 111.16,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.215
        },
        {
          "time": 111.375,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.318
        },
        {
          "time": 111.693,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.25
        },
        {
          "time": 111.964,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.073
        },
        {
          "time": 112.38,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.094
        },
        {
          "time": 112.479,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.135
        },
        {
          "time": 112.615,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.083
        },
        {
          "time": 112.885,
          "lane": "left",
          "x": 0.69,
          "type": "iceCream",
          "pitch": 90,
          "vocalDuration": 0.302
        },
        {
          "time": 113.208,
          "lane": "right",
          "x": 0.08,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.167
        },
        {
          "time": 113.5,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.078
        },
        {
          "time": 113.714,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 113.979,
          "lane": "left",
          "x": 0.1,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 114.458,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 114.688,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 114.917,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.146,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.375,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 115.604,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 116.089,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.13
        },
        {
          "time": 117.552,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.206
        },
        {
          "time": 117.758,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.206
        },
        {
          "time": 117.964,
          "lane": "left",
          "x": 0.1,
          "type": "donut",
          "pitch": 67,
          "vocalDuration": 0.083
        },
        {
          "time": 118.552,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 118.781,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.01,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.24,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.469,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.698,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 119.932,
          "lane": "right",
          "x": 0.1,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.141
        },
        {
          "time": 120.49,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.167
        },
        {
          "time": 121.161,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.229
        },
        {
          "time": 121.464,
          "lane": "left",
          "x": 0.1,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.167
        },
        {
          "time": 121.693,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.125
        },
        {
          "time": 121.922,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.271
        },
        {
          "time": 123.74,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.146
        },
        {
          "time": 123.885,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.26
        },
        {
          "time": 124.151,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.141
        },
        {
          "time": 124.292,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.234
        },
        {
          "time": 124.531,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.172
        },
        {
          "time": 125.672,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 125.888,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 126.177,
          "lane": "left",
          "x": 0.11,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.146
        },
        {
          "time": 126.323,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.307
        },
        {
          "time": 126.641,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.26
        },
        {
          "time": 127.651,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.151
        },
        {
          "time": 127.802,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.13
        },
        {
          "time": 127.932,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 128.164,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 128.401,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 77,
          "vocalDuration": 0.156
        },
        {
          "time": 128.688,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 69,
          "vocalDuration": 0.13
        },
        {
          "time": 129.948,
          "lane": "right",
          "x": 0.46,
          "type": "fish",
          "pitch": 89,
          "vocalDuration": 0.24
        },
        {
          "time": 130.49,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.115
        },
        {
          "time": 130.62,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.12
        },
        {
          "time": 130.745,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.219
        },
        {
          "time": 131.021,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.188
        },
        {
          "time": 131.214,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.429,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.644,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.215
        },
        {
          "time": 131.943,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.182
        },
        {
          "time": 132.182,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 132.49,
          "lane": "right",
          "x": 0.39,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.177
        },
        {
          "time": 132.667,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 133.01,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.089
        },
        {
          "time": 133.208,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.457,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.705,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.958,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.174,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.389,
          "lane": "right",
          "x": 0.14,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.215
        },
        {
          "time": 134.609,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 134.842,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.074,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.307,
          "lane": "right",
          "x": 0.6,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.539,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 135.771,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.004,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.236,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.232
        },
        {
          "time": 136.474,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 136.704,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 136.934,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.164,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.394,
          "lane": "left",
          "x": 0.14,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.624,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 137.853,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.23
        },
        {
          "time": 138.474,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 138.724,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 139,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.276
        },
        {
          "time": 139.286,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.193
        },
        {
          "time": 139.505,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 139.737,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 139.974,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 140.281,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.219
        },
        {
          "time": 141.146,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 141.432,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 141.719,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.266
        },
        {
          "time": 141.984,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.266
        },
        {
          "time": 142.255,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.333
        },
        {
          "time": 142.594,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 142.822,
          "lane": "right",
          "x": 0.16,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.051,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.279,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.508,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.736,
          "lane": "right",
          "x": 0.6,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 143.965,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 144.193,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.229
        },
        {
          "time": 144.427,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 144.682,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 144.938,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.193,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.448,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 145.703,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 146.469,
          "lane": "left",
          "x": 0.14,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 146.693,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.302
        },
        {
          "time": 146.995,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 147.224,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 147.464,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 147.948,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 148.193,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 148.469,
          "lane": "right",
          "x": 0.14,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.203
        },
        {
          "time": 148.677,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 148.908,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.138,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.368,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.599,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 149.829,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.06,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.29,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.23
        },
        {
          "time": 150.615,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 150.843,
          "lane": "right",
          "x": 0.14,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.072,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.3,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.529,
          "lane": "left",
          "x": 0.14,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.757,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 151.986,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 152.214,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.229
        },
        {
          "time": 152.448,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.146
        },
        {
          "time": 152.599,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 152.845,
          "lane": "left",
          "x": 0.56,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.092,
          "lane": "right",
          "x": 0.12,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.339,
          "lane": "left",
          "x": 0.34,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.585,
          "lane": "right",
          "x": 0.34,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 153.832,
          "lane": "left",
          "x": 0.12,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.247
        },
        {
          "time": 154.323,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.073
        },
        {
          "time": 154.484,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 72,
          "vocalDuration": 0.242
        },
        {
          "time": 154.727,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 72,
          "vocalDuration": 0.242
        },
        {
          "time": 154.969,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 155.219,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.276
        },
        {
          "time": 155.495,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 155.74,
          "lane": "right",
          "x": 0.14,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 155.984,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.208
        },
        {
          "time": 157.151,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.377,
          "lane": "left",
          "x": 0.13,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.603,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 157.829,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 158.055,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.226
        },
        {
          "time": 158.281,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.5,
          "lane": "right",
          "x": 0.34,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.172
        },
        {
          "time": 158.672,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 158.943,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.271
        },
        {
          "time": 159.219,
          "lane": "left",
          "x": 0.34,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.182
        },
        {
          "time": 159.406,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 159.643,
          "lane": "left",
          "x": 0.13,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 159.879,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.116,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.352,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.589,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 160.826,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.062,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.299,
          "lane": "right",
          "x": 0.13,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.535,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 161.772,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 162.008,
          "lane": "left",
          "x": 0.13,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 162.292,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.156
        },
        {
          "time": 162.51,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.146
        },
        {
          "time": 162.661,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 162.866,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 163.071,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.205
        },
        {
          "time": 163.276,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.208
        },
        {
          "time": 163.484,
          "lane": "right",
          "x": 0.16,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 163.738,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 163.992,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 164.246,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.254
        },
        {
          "time": 164.552,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 164.794,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.036,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.279,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 165.521,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 165.747,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 166,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.208
        },
        {
          "time": 166.281,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 69,
          "vocalDuration": 0.188
        },
        {
          "time": 166.49,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.224
        },
        {
          "time": 166.719,
          "lane": "left",
          "x": 0.14,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 166.977,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.258
        },
        {
          "time": 167.24,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.276
        },
        {
          "time": 167.516,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.219
        },
        {
          "time": 167.734,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 167.998,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 168.262,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 168.526,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 168.762,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 168.997,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 169.233,
          "lane": "left",
          "x": 0.14,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.236
        },
        {
          "time": 169.5,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.12
        },
        {
          "time": 169.656,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.193
        },
        {
          "time": 169.854,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.156
        },
        {
          "time": 170.464,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 74,
          "vocalDuration": 0.135
        },
        {
          "time": 170.604,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 170.814,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 171.024,
          "lane": "right",
          "x": 0.15,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.21
        },
        {
          "time": 171.24,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.292
        },
        {
          "time": 171.531,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 171.777,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.023,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.27,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.246
        },
        {
          "time": 172.531,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 172.779,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.026,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.273,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 173.521,
          "lane": "right",
          "x": 0.14,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 173.776,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.255
        },
        {
          "time": 174.036,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.219
        },
        {
          "time": 174.5,
          "lane": "left",
          "x": 0.13,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.26
        },
        {
          "time": 174.76,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 175.005,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.245
        },
        {
          "time": 175.25,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 175.484,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.234
        },
        {
          "time": 175.719,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.281
        },
        {
          "time": 176,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.198
        },
        {
          "time": 176.198,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.198
        },
        {
          "time": 176.443,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 81,
          "vocalDuration": 0.237
        },
        {
          "time": 176.68,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 81,
          "vocalDuration": 0.237
        },
        {
          "time": 176.917,
          "lane": "left",
          "x": 0.14,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.05
        },
        {
          "time": 176.917,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.266
        },
        {
          "time": 177.182,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 177.446,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 177.71,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.264
        },
        {
          "time": 178.036,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.333
        },
        {
          "time": 178.474,
          "lane": "left",
          "x": 0.53,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 178.745,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 178.839,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.067,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.295,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.523,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 179.751,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.228
        },
        {
          "time": 180.5,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 180.797,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.04,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.282,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.525,
          "lane": "right",
          "x": 0.08,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 181.768,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.243
        },
        {
          "time": 182.521,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 182.776,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.255
        },
        {
          "time": 183.036,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.272,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.508,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 183.743,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.236
        },
        {
          "time": 184.182,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.156
        },
        {
          "time": 184.344,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.13
        },
        {
          "time": 184.479,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 184.615,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.094
        },
        {
          "time": 184.792,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.135
        },
        {
          "time": 185.021,
          "lane": "left",
          "x": 0.09,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.203
        },
        {
          "time": 185.229,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 185.495,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.125
        },
        {
          "time": 185.74,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 185.974,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.172
        },
        {
          "time": 186.474,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 186.715,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 186.957,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.198,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.439,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 187.681,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.241
        },
        {
          "time": 188.016,
          "lane": "right",
          "x": 0.54,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.094
        },
        {
          "time": 188.115,
          "lane": "left",
          "x": 0.29,
          "type": "donut",
          "pitch": 62,
          "vocalDuration": 0.104
        },
        {
          "time": 188.51,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 188.75,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 188.99,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.229,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.469,
          "lane": "right",
          "x": 0.08,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 189.708,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.24
        },
        {
          "time": 190.547,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 190.805,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.063,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.32,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.578,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 191.836,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.258
        },
        {
          "time": 192.464,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.115
        },
        {
          "time": 192.583,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.255
        },
        {
          "time": 192.953,
          "lane": "right",
          "x": 0.11,
          "type": "sushi",
          "pitch": 69,
          "vocalDuration": 0.224
        },
        {
          "time": 193.177,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.436,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.694,
          "lane": "left",
          "x": 0.11,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.259
        },
        {
          "time": 193.958,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.193
        },
        {
          "time": 194.151,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 69,
          "vocalDuration": 0.193
        },
        {
          "time": 194.479,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.161
        },
        {
          "time": 194.74,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 194.988,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.235,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.483,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 195.731,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.248
        },
        {
          "time": 196.219,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.078
        },
        {
          "time": 196.302,
          "lane": "left",
          "x": 0.09,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.182
        },
        {
          "time": 196.505,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 196.755,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.005,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.255,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.505,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 197.755,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.25
        },
        {
          "time": 198.01,
          "lane": "right",
          "x": 0.1,
          "type": "fish",
          "pitch": 67,
          "vocalDuration": 0.094
        },
        {
          "time": 198.516,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 198.734,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 198.953,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 199.172,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.219
        },
        {
          "time": 199.391,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 199.592,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 199.793,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.201
        },
        {
          "time": 200.479,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 200.62,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 62,
          "vocalDuration": 0.104
        },
        {
          "time": 200.786,
          "lane": "right",
          "x": 0.09,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.089
        },
        {
          "time": 200.938,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 201.047,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.135
        },
        {
          "time": 201.229,
          "lane": "left",
          "x": 0.08,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.125
        },
        {
          "time": 201.526,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.177
        },
        {
          "time": 201.745,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 201.979,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.156
        },
        {
          "time": 202.625,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 202.845,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.064,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.284,
          "lane": "right",
          "x": 0.08,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.503,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 203.723,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.22
        },
        {
          "time": 204.109,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.063
        },
        {
          "time": 204.313,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 204.51,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 204.756,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.002,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.247,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.493,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 205.739,
          "lane": "right",
          "x": 0.09,
          "type": "fish",
          "pitch": 65,
          "vocalDuration": 0.246
        },
        {
          "time": 206.359,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 65,
          "vocalDuration": 0.177
        },
        {
          "time": 206.542,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 64,
          "vocalDuration": 0.271
        },
        {
          "time": 206.818,
          "lane": "left",
          "x": 0.08,
          "type": "candy",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.047,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.276,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.505,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 207.734,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 64,
          "vocalDuration": 0.229
        },
        {
          "time": 208.297,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.073
        },
        {
          "time": 208.495,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.234
        },
        {
          "time": 209.182,
          "lane": "right",
          "x": 0.08,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.188
        },
        {
          "time": 209.443,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.109
        },
        {
          "time": 209.703,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 64,
          "vocalDuration": 0.193
        },
        {
          "time": 209.927,
          "lane": "left",
          "x": 0.1,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.193
        },
        {
          "time": 210.125,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 67,
          "vocalDuration": 0.109
        },
        {
          "time": 210.349,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.276
        }
      ]
    }
  }
};
